import * as Dialogs from "oc-ui/dialogs/Dialogs";
import { useAlertForDialogs } from "oc-ui/dialogs/Dialogs";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Segment } from "./Segment";
import { FlügelÖffnungsbereichZylinderSektor, ZElement } from "./ZElement";
import {
  elementOrTor,
  findAuswahl,
  getDreifachtorPartnerElement,
  getStandardSize,
  isSchiebetorForm,
} from "./elementFunctions";
import { MyModelGhostPool } from "./MyModelGhostPool";
import { v2, v3 } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";
import { box3AndMatrixToOBB, v2To3 } from "oc-threejs/Maths3";
import { Jaco3d } from "oc-jaco3d/arrangement3d/Jaco3d";
import * as Maths from "oc-commons/Maths";
import * as Commons from "oc-commons/Commons";
import { maxFrequent } from "oc-commons/Commons";
import {
  filterPathIntersectionCached,
  findPathIntersectionCached,
  following_are_optionals,
  sortForSortierung,
} from "oc-app/metadata/GraphMetadata";
import { assertNotNull } from "oc-scene-editor/global";
import { Ecke } from "./Ecke";
import { Collisions } from "oc-threejs/collision/Collisions";
import { Bag } from "oc-commons/Bag2";
import {
  getWarnungWichtigkeitColor,
  mergeWarnungenByText,
  Warnung,
  WarnungZylinderSektor,
} from "./Warnung";
import { Pfosten } from "./Pfosten";
import { sollAbschlussleisteObenErscheinen } from "./Füllung";
import { Aufbau } from "./Aufbau";
import { Stromkabel } from "./Stromkabel";
import {
  BaugruppenEintrag,
  BestelllistenEintrag,
  createStückliste,
  StücklistenIterator,
} from "./Stückliste";
import { Box3, Matrix4, Object3D, Vector2, Vector3 } from "three";
import { setEmptyAsMauer } from "../components/zauneditor/ZaunCircleMenuItemEmptyAsMauer";
import {
  filterUniqueSetsBy,
  getTypeNameOfPart,
  lichtleistenZubehörAnzahlKeyfilter,
  löscheNachbarElementeUmMindestplatzZuErreichen,
  prependHistory,
  schneideEckenUndSegmente,
} from "./arrangementFunctions";
import { pfostenbreiteCirca } from "./grundrissFunctions";
import { formatLength } from "../commons/Utils";
import {
  MAuswahlwert,
  MDetailSerie,
  MElement,
  MInspiration,
  MPfosten,
  MSerie,
  MZubehoer,
} from "../../metamodell";
import { PAuswahlwert, PInspiration, PSerie } from "../../metamodell_paths";
import { I18N } from "oc-I18N";
import {
  getEckadapterInfo,
  getLückenTeile,
  getLückeZwischen,
  getPfostenWinkelListe,
  getVorläufigeElementeAnEcke,
  isAufgeschraubt,
  isKlemmpfosten,
} from "./pfostenFunctions";
import { Grundriss } from "./Grundriss";
import {
  ElementAuswahlAccessor,
  ElementAuswahlAccessorKey,
  filterElementAuswahlAccessorenForMany,
} from "./ElementAuswahlAccessoren";
import {
  PfostenAuswahlAccessorKey,
  filterPfostenAuswahlAccessorenForMany,
} from "./PfostenAuswahlAccessoren";
import { getHinweistexteAuswahlwertKeys } from "./hinweistextFunctions";
import {
  getKabelbäumeFromArrangement,
  getTrafoTypAusgewöhlt,
  iterateLichtleistenWarnungen,
  startPositionOfTree,
  Tree,
  verlegeKabelEntlangDesBaumes,
} from "./lichtleistenFunctions";
import { lowDiscrepancyColorSequence } from "../arrangement3d/lowDiscrepancyColorSequence";
import { Eckadapter } from "./Eckadapter";
import {
  getAngleIntervalType,
  istEckadapter,
  sindWinkelVielfache,
} from "../commons/AngleIntervals";
import { OBB } from "three/examples/jsm/math/OBB";
import { Part } from "./Part";
import { OcAxisHelper } from "oc-threejs/objects/OcAxisHelper";
import { Empty } from "./Empty";
import { Fundament } from "./Fundament";
import { getDefaultAnzahl } from "../components/zauneditor/Zusatzartikel";
import { Zauneditor } from "../pages/Zauneditor";
import {
  WARNUNG_DIALOG_KEYS,
  WarnungDialogKey,
  createWarnungDialogConfig,
  getWarnungWichtigkeitByKey,
  isWarnungDialogSuppressed,
} from "./WarnungDialogFactory";
export const agt = () => APP.arrangement;

export function getAbschlussleistenAuswahlwerteForElemente(
  arrayOfMetaAndSize: Array<{ meta: MElement; size: { y: number } }>
) {
  const abschlussleisteAuswahlwerteSet = new Set<MAuswahlwert>();
  const addAbschlussleistenWerte = (array?: Array<Partial<{ Auswahlwert: MAuswahlwert }>>) =>
    array?.forEach((x) => abschlussleisteAuswahlwerteSet.add(x.Auswahlwert));
  arrayOfMetaAndSize.forEach(({ meta, size }) => {
    if (sollAbschlussleisteObenErscheinen(meta, size.y)) {
      addAbschlussleistenWerte(meta.AbschlussleisteOben);
    }
    addAbschlussleistenWerte(meta.AbschlussleisteUnten);
  });
  return sortForSortierung(Array.from(abschlussleisteAuswahlwerteSet));
}

export class Arrangement extends Jaco {
  isArrangement = true;

  // ----------------------------------------------------------------------------------
  // Torkonfigurator-spezifische optionale Eigenschaften (definiert in ArrangementMass)
  // ----------------------------------------------------------------------------------
  konfiguration?: import("../torkonfigurator/Konfiguration").Konfiguration;
  massRuler?: import("../torkonfigurator/MassRuler").MassRuler;
  getCurrentElement?(): import("./ZElement").ZElement;
  getCurrentElementEinzeltor?(): import("./ZElement").ZElement;
  getSegment?(): Segment;

  // ----------------------------------------------------------------------------------
  // persistierte Werte - Zustand, werden mit der Konfiguration gespeichert
  // ----------------------------------------------------------------------------------

  /** @type {Grundriss} */
  grundriss = new Grundriss(this);
  segmente: Segment[] = [];
  private _inspiration: MInspiration = null;
  serie: MSerie = null;
  aufbauten: Aufbau[] = [];
  userDefinedArticles: Array<{ description: string; amount: number; price: number }> = [];
  kabel: Stromkabel[] = [];
  lichtleistenSplitter = 0;
  _zaunart: MAuswahlwert = null;
  pfostenartAuswahlwert: MAuswahlwert = null;
  lichttrafoAuswahlwert: MAuswahlwert = null;
  lichtleistenZubehörAnzahl: Record<string, number> = {};
  anschlagprofilfarbeAuswahlwert_: MAuswahlwert = null;
  pfostenfarbeAuswahlwert_: MAuswahlwert = null;
  bodenbefestigungAuswahlwert_: MAuswahlwert = null;
  elementhalterAuswahlwert_: MAuswahlwert = null;
  verteilungsstrategieAuswahlwert_: MAuswahlwert = null;
  anschlagprofilfarbeDefault: MAuswahlwert;
  bodenbefestigungAuswahlwerte: MAuswahlwert[];
  elementhalterAuswahlwerte: MAuswahlwert[];
  füllungAuswahlwertDefault: MAuswahlwert = null;
  profilAuswahlwert_: MAuswahlwert = null;
  profilAuswahlwertDefault: MAuswahlwert = null;
  profilPosition_: number | "center" | null = null;
  profilleisteAuswahlwert_: MAuswahlwert = null;
  profilleisteAuswahlwertDefault: MAuswahlwert = null;
  abschlussleisteAuswahlwert_: MAuswahlwert = null;
  aufsatzleisteAuswahlwert_: MAuswahlwert = null;
  massAuswahlwertDefault: MAuswahlwert = null;
  pfostenfarbeAuswahlwertDefault: MAuswahlwert = null;
  bodenbefestigungAuswahlwertDefault: MAuswahlwert = null;
  elementhalterAuswahlwertDefault: MAuswahlwert = null;
  sizeDefault: Vector3 = null;

  // ----------------------------------------------------------------------------------
  // session Werte - Zustand, werden beim App-Neustart zurückgesetzt
  // ----------------------------------------------------------------------------------

  INSIDE_ARRANGEMENT_UPDATE3D = false;
  MAX_UPDATE_CYCLES = 10;
  THROW_ERROR_ON_DIVERGENT_UPDATES = false;
  selectedObjects: any[] = [];
  copiedEntity: any = null;
  zauneditorReady = false;
  zauneditorVisited = false;
  activeTabKey = "Elemente";
  elementeSeiteGewechseltFragenAnzahl = 3;
  elementeSeiteGewechselt = new Set<ZElement>();
  ankerAußenFragenAnzahl = 1;
  ankerAußen = new Set<Pfosten>();
  auswahlAccessoren: Partial<
    Record<ElementAuswahlAccessorKey | PfostenAuswahlAccessorKey, ElementAuswahlAccessor>
  > = {};
  showStückliste = false;
  mostRecentPfostenart: MAuswahlwert = null;
  mostRecentBodenbefestigung: MAuswahlwert = null;
  maybeShowUmmantelungWarnung = false;
  updatingPfostenart = false;
  highlightProfileActive = false;
  recentlyIndividualisiertAuswahlwert: string = null;
  showAllIndividualisiert = false;
  /** Selektion der Füllung
   * * wenn ein Element selektiert ist, dann muss sich die selektierte Füllung nach dessen Füllung richten.
   *    * wenn mehrere Elemente selektiert sind, dann nach dem ersten
   * * History
   *   * speziell für die Elementleiste gibt es eine History der selektierten Füllungen (ein unique-Array,
   *     in dem alle Füllungen der Serie enthalten sind, und das nach Last-Recently-Selected sortiert ist)
   *   * Die gerade selektierte Füllung ist das erste Element der History
   * * Beim Betreten des Zauneditors
   *   * muss der Default aus der Inspiration selektiert sein, wenn es kein Element gibt.
   *   * muss die History gleich der Element-Füllungs Häufigkeit der Szene sortiert sein, wenn es ein Element gibt.
   */
  füllungAuswahlwertHistory: MAuswahlwert[] = [];
  backupForZauneditorComparison = null;
  isMultiselecting = false;
  nurMasseUpdaten = false;
  grundrissDialogOpen = true;

  // ----------------------------------------------------------------------------------
  // abgeleitete Werte - d.h. sind letztlich nur berechnet (in update3d) und gecached, kein Zustand
  // Achtung, diese Werte muss man immer ganz besonders im Auge haben, kann sein,
  // dass sie fälschlich doch als Zustand dienen, und das führt dann zu schwierigen Bugs
  // ----------------------------------------------------------------------------------

  ghostPool = new MyModelGhostPool(this);
  eckadapter: Eckadapter[] = [];
  warnungen: Warnung[] = [];
  elementeMitBreiteWarnung = new Set<ZElement>();
  elementeMitProfilpositionsWarnung = new Set<ZElement>();
  ecken: Ecke[] = [];
  bestellliste: BestelllistenEintrag[] = [];
  baugruppen: BaugruppenEintrag[][] = [];
  customAnzahlen: Record<string, number> = {};
  gesamtpreis = 0;
  isSeitenleiste = false;
  trafoTrees: Tree[];
  fadeOutObjects: Object3D[];
  hasOnlyRhombusLichtleisten = false;

  traverse(iterator: (jaco: Jaco) => void) {
    super.traverse(iterator);
    if (this.segmente) this.segmente.forEach((s) => s.traverse(iterator));
    if (this.aufbauten) this.aufbauten.forEach((s) => s.traverse(iterator));
    if (this.kabel) this.kabel.forEach((k) => k.traverse(iterator));
    if (this.warnungen) this.warnungen.forEach((s) => s.traverse(iterator));
    this.getEckpfosten().forEach((s) => s.traverse(iterator));
    this.eckadapter.forEach((a) => a.traverse(iterator));
    this.ghostPool.traverse(iterator);
  }

  storeBackupForZauneditorComparison() {
    this.backupForZauneditorComparison = this.toJSON();
  }

  isBackupForZauneditorComparisonSame() {
    return Commons.isEqualEpsilon(this.backupForZauneditorComparison, this.toJSON());
  }

  get füllungAuswahlwert() {
    return this.füllungAuswahlwertHistory[0];
  }

  set füllungAuswahlwert(füllungAuswahlwert: MAuswahlwert) {
    this.füllungAuswahlwertHistory = prependHistory(
      füllungAuswahlwert,
      this.füllungAuswahlwertHistory
    );
  }

  get abschlussleisteAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isElement && this.selectedObjects[0]?.abschlussleisteAuswahlwert) ??
      this.abschlussleisteAuswahlwert_
    );
  }

  get aufsatzleisteAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isElement && this.selectedObjects[0]?.aufsatzleisteAuswahlwert) ??
      this.aufsatzleisteAuswahlwert_
    );
  }

  get massAuswahlwert(): MAuswahlwert {
    return this.selectedObjects[0]?.isElement && this.selectedObjects[0]?.massAuswahlwert;
  }

  get pfostenfarbeAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isPfosten && this.selectedObjects[0]?.pfostenfarbeAuswahlwert) ??
      this.pfostenfarbeAuswahlwert_
    );
  }

  get anschlagprofilfarbeAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isTor &&
        this.selectedObjects[0].getWandmontagePlatten()?.[0]?.anschlagprofilfarbeAuswahlwert) ??
      this.anschlagprofilfarbeAuswahlwert_
    );
  }

  get bodenbefestigungAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isPfosten &&
        this.selectedObjects[0]?.bodenbefestigungAuswahlwert) ??
      this.bodenbefestigungAuswahlwert_
    );
  }

  get elementhalterAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isPfosten && this.selectedObjects[0]?.elementhalterAuswahlwert) ??
      this.elementhalterAuswahlwert_
    );
  }

  get verteilungsstrategieAuswahlwert(): MAuswahlwert {
    return (
      (!this.selectedObjects[0]?.isPfostenAnEcke &&
        this.selectedObjects[0]?.segment?.verteilungsstrategieAuswahlwert) ??
      this.verteilungsstrategieAuswahlwert_
    );
  }

  get profilAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isElement && this.selectedObjects[0]?.profilAuswahlwert) ??
      this.profilAuswahlwert_
    );
  }

  get profilleisteAuswahlwert(): MAuswahlwert {
    return (
      (this.selectedObjects[0]?.isElement && this.selectedObjects[0]?.profilleisteAuswahlwert) ??
      this.profilleisteAuswahlwert_
    );
  }

  constructor() {
    super(undefined);
    this.inspiration = APP.richMetadata.findInspiration(APP.inspirationName);
    this.zaunart = APP.richMetadata.findAuswahlwert(APP.zaunartName);
    this.verteilungsstrategieAuswahlwert_ =
      APP.richMetadata.getAuswahlWertVoreinstellungForKey("Verteilungsstrategie");
    this.lichtleistenZubehörAnzahl = this.getDefaultLichtleistenZubehörAnzahl();
  }

  get zaunart(): MAuswahlwert {
    return this._zaunart;
  }

  set zaunart(v: MAuswahlwert) {
    this._zaunart = v;
    if (v) {
      const inspiration = this.zaunart.Inspiration.filter(
        (insp) => insp.DetailSerie.Auswahlwert.Voreinstellung && insp.Inspiration.Voreinstellung
      );
      // Default Inspiration
      this.inspiration = _.first(inspiration);
    }
  }

  get inspiration(): MInspiration {
    return this._inspiration;
  }

  set inspiration(v: MInspiration) {
    this._inspiration = v;
    if (v) {
      this.serie = findPathIntersectionCached("Arrangement.js:333")(
        this.inspiration,
        (p: PInspiration) => p.DetailSerie.Serie
      );
      assertNotNull("serie", this.serie);
      this.füllungAuswahlwertDefault = findPathIntersectionCached("Arrangement.js:335")(
        this.inspiration,
        (p: PInspiration) => p.Füllung,
        this.serie,
        (p: PSerie) => elementOrTor(p.DetailSerie).Füllung.Auswahlwert
      );
      assertNotNull("füllungAuswahlwertDefault", this.füllungAuswahlwertDefault);
      this.initFüllungAuswahlwertHistory();
      this.massAuswahlwertDefault = findPathIntersectionCached("Arrangement.js:343")(
        this.inspiration,
        (p: PInspiration) => p.Mass.Auswahlwert,
        following_are_optionals,
        this.serie,
        (p: PSerie) => elementOrTor(p.DetailSerie).Mass.Auswahlwert
      );
      assertNotNull("massAuswahlwertDefault", this.massAuswahlwertDefault);
      this.profilAuswahlwertDefault = findPathIntersectionCached("Arrangement.js:350")(
        this.füllungAuswahlwertDefault,
        (f: PAuswahlwert) => f.Füllung_Objekt.Element.Profilkategorie.Profile.Auswahlwert
      );
      this.profilleisteAuswahlwertDefault = findPathIntersectionCached("Arrangement.js:354")(
        this.füllungAuswahlwertDefault,
        (f: PAuswahlwert) => f.Füllung_Objekt.Element.Profilkategorie.Profilleiste.Auswahlwert
      );
      this.sizeDefault = v2To3(this.inspiration.Mass.Standard, 0.2);
      const pfostenfarbeAuswahlwerte = filterPathIntersectionCached("Arrangement.js:359")(
        this.serie,
        (serie: PSerie) => serie.DetailSerie.Pfosten.Pfostenfarbe.Auswahlwert
      );
      this.pfostenfarbeAuswahlwertDefault = APP.richMetadata.ensureAuswahlWert(
        pfostenfarbeAuswahlwerte,
        this.pfostenfarbeAuswahlwert
      );
      this.anschlagprofilfarbeDefault = APP.richMetadata.findAuswahlwertOrDefault(
        this.anschlagprofilfarbeAuswahlwert?.Key,
        "Anschlagprofilfarbe"
      );
      this.bodenbefestigungAuswahlwerte = filterPathIntersectionCached("Arrangement.js:367")(
        this.serie,
        (serie: PSerie) => serie.DetailSerie.Pfosten.Bodenbefestigung.Auswahlwert
      );
      this.bodenbefestigungAuswahlwertDefault = APP.richMetadata.ensureAuswahlWert(
        this.bodenbefestigungAuswahlwerte,
        this.bodenbefestigungAuswahlwert
      );
      this.elementhalterAuswahlwerte = filterPathIntersectionCached("Arrangement.js:375")(
        this.serie,
        (serie: PSerie) => serie.DetailSerie.Pfosten.Elementhalter.Auswahlwert
      );
      this.elementhalterAuswahlwertDefault = APP.richMetadata.ensureAuswahlWert(
        this.elementhalterAuswahlwerte,
        this.elementhalterAuswahlwert
      );
    }
  }

  getSelectedOrAllElemente(): ZElement[] {
    return this.selectedObjects.length > 0 && this.selectedObjects.some((e) => e.isElement)
      ? this.selectedObjects.filter((e) => e.isElement)
      : this.getElemente();
  }

  getSelectedOrAllPfosten(): Pfosten[] {
    return this.selectedObjects.length > 0 && this.selectedObjects.some((e) => e.isPfosten)
      ? this.selectedObjects.filter((e) => e.isPfosten)
      : this.getPfosten();
  }

  get isElementeEinzelnListen(): boolean {
    return (
      filterPathIntersectionCached("Arrangement.js:368")(
        this.füllungAuswahlwert,
        (p: PAuswahlwert) => elementOrTor(p.Füllung_Objekt).DetailSerie
      ) as MDetailSerie[]
    ).some((detailSerie) => detailSerie.ElementeEinzelnListen);
  }

  get isIndividualisierteParts(): boolean {
    return this.getPartsAndPfosten().some((p) => p.hasIndividualisierteAuswahlwerte);
  }

  private _getPfostenIdPfostenartAuswahlwertMap(): Map<number, MAuswahlwert> {
    return new Map(this.getPfosten().map((p) => [p.id, p.pfostenartAuswahlwert]));
  }

  update3d() {
    if (this.INSIDE_ARRANGEMENT_UPDATE3D) {
      // wenn das hier auftritt: update3d arbeitet ja sowieso in mehreren cyclen, reicht das nicht?
      // Sonst APP.dirty()
      throw new Error("recursive arrangement.update3d is forbidden");
    }
    this.INSIDE_ARRANGEMENT_UPDATE3D = true;
    try {
      // console.time("update3d");
      const trackPfostenWechsel = this._getPfostenIdPfostenartAuswahlwertMap();
      const trackEmptyChanges = new Map(this.getEmpties().map((e) => [e.id, e.breite]));
      const torBreiteMap = new Map(this.getTore().map((tor) => [tor, tor.breite]));
      super.update3d();

      // console.time('update3d');
      this.ghostPool.withPoolClean(() => {
        super.update3d();
        this.updateGrundriss();
        this.updateAufbauten();

        // Problem: Eckpfosten => Eckadapter => Segment + Element => Eckpfosten ...
        // Es ist richtig, erst die Ecken und die Segmente zu bestimmen.
        // Dann: Ermitteln, welche Elemente an einer Ecke anliegen.
        // Dann: Ermitteln der Eckpfosten und Eckadapter
        // Dann: Finales Segment-update3d inkl. Pfosten / UMProfile / Elemente positionieren
        const elementeBefore = new Set(this.getElemente());

        const cycler = (inner: (i: number) => void) => {
          const partMapper = (p) => ({
            breite: p.breite,
            x: p.position.x,
            key: p.meta?.Key ?? getTypeNameOfPart(p),
          });
          // Speichert alle bisherigen Zustände
          const dumpsAndWarnings: { dump: any; fehlerfrei: boolean }[] = [];
          const max_cycles = this.MAX_UPDATE_CYCLES;
          let endlosSchleifeMitFehlerfreiemEintrag = false;
          let i;
          for (i = 0; i <= max_cycles; i++) {
            const dump = this.getPartsAndPfosten().map(partMapper);
            const fehlerfrei = this.warnungen.length == 0;
            if (i > 0) {
              if (!endlosSchleifeMitFehlerfreiemEintrag) {
                const equals = (a, b) => Commons.isEqualEpsilon(a, b, 0.005);
                // Prüfe, ob der aktuelle Zustand bereits in einer früheren Iteration vorkam
                let endlosschleifetartIndex = dumpsAndWarnings.findLastIndex((prev, index) =>
                  equals(prev.dump, dump)
                );
                const istKonvergent = endlosschleifetartIndex === i - 1;
                if (istKonvergent) {
                  // Perfekt! Das aktuelle und letzte Update führen zum selben Ergebnis, also kann man sofort aussteigen
                  break;
                }
                // Die letzten beiden Updates sind also divergent.
                if (endlosschleifetartIndex !== -1) {
                  // Endlosschleife erkannt. Tritt auf in speziellen Situationen wie
                  // testEckeMitDivergenterEndlosschleifeOhneWarnungen, weil z.b. der freie Platz für ein Element
                  // und der durch das Element bedingte breitere Typ eines Pfostens sich wechselseitig ausschließen

                  const esGabEinenFehlerfreienEintrag = dumpsAndWarnings.some(
                    (entry, index) => index >= endlosschleifetartIndex && entry.fehlerfrei
                  );
                  if (esGabEinenFehlerfreienEintrag) {
                    if (fehlerfrei) {
                      // Wir sind zum fehlerfreien Zustand zurückgekehrt. Es ist zwar nicht ideal - besser wäre
                      // es, keine Endlosschleife zu haben. Aber wir haben wenigstens einen fehlerfreien Zustand
                      // erreicht. Also brechen wir mit einem ausgeloggten Hinweis aus der Endlosschleife aus.
                      console.warn(
                        "divergente arrangement inner updates mit Endlosschleife aber fehlerfreiem Ausstieg nach " +
                          i +
                          " Zyklen"
                      );
                      break;
                    }
                    endlosSchleifeMitFehlerfreiemEintrag = true;
                  } else {
                    // Es gibt keinen fehlerfreien Eintrag in der Endlosschleife – sofort abbrechen.
                    const message =
                      "divergente arrangement inner updates mit Endlosschleife nach " +
                      i +
                      " Zyklen";
                    if (this.THROW_ERROR_ON_DIVERGENT_UPDATES) {
                      throw new Error(message);
                    }
                    console.warn(message);
                    break;
                  }
                }
              }

              if (i == max_cycles) {
                // Commons.logDeepDiffWithValues(lastDump, dump, equals);
                const message =
                  "*** divergente arrangement inner updates auch nach " + i + " Zyklen => Abbruch";
                if (this.THROW_ERROR_ON_DIVERGENT_UPDATES) {
                  throw new Error(message);
                }
                console.error(message);
                break;
              }
            }
            // console.log("*** arrangement inner update cycle ", i + 1);
            // Commons.logDeepDiffWithValues(dumpsAndWarnings.at(-1)?.dump, dump);
            dumpsAndWarnings.push({ dump, fehlerfrei });
            inner(i);

            // wenn man ein Problem mit divergenten Updates debuggen will, ist es oft hilfreich,
            // sich den Stand nach dem allerersten Update-Zyklus anzuschauen. Dafür hier das break;
            // unkommentieren und sicherstellen, dass im Test nach der fertigen Testsituation
            // nur ein update und kein dirty aufgerufen wird
            // break;
          }
          // console.log("arrangement update cycles ", i);
        };

        const getTorOderEckpfosten = () =>
          new Set([...this.getEckpfosten(), ...this.getTorpfosten()]);

        // entferne temporär die Eckpfosten aus den Segment-Parts - im Laufe des Segment.update3d werden die
        // Eckpfosten den Segmenten wieder hinzugefügt, aber sie dürfen nicht von Anfang an drin sein
        this.segmente.forEach((segment) => {
          segment.pfosten = segment.pfosten.filter((p) => !p.isPfostenAnEcke);
        });

        // Durch die mehrfachen Update-Zyklen müssen die eventuell zu viel erzeugten jaco3ds
        // später auch wieder abgeräumt werden. Dazu dient der jaco3dReset
        const jaco3dReset = (() => {
          const getJaco3Ds = () => {
            const set = new Set<Jaco3d>();
            this.traverse((j) => {
              const jaco3d = j.jaco3d;
              if (jaco3d) {
                set.add(jaco3d);
              }
            });
            return set;
          };
          const changedBefore = getJaco3Ds().filter((j) => j._updateId === APP._currentUpdateId);
          return () => {
            getJaco3Ds()
              // Alle vor dem Eintreten in die Cycles getouchten Jaco3ds sollen weiter getouched bleiben
              .difference(changedBefore)
              // alle anderen werden resetted
              .forEach((jaco3d: Jaco3d) => {
                jaco3d._updateId = 0;
              });
          };
        })();

        cycler((i) => {
          if (i > 0) jaco3dReset();
          this.schneideEckenUndSegmente();
          this.segmente.forEach((segment) => {
            segment.parts = segment.parts.filter((p: any) => !p.isPfostenAnEcke);
          });
          this.updateEckpfosten();
          this.updateEckadapter();
          this.updateParts(elementeBefore);
          this.getEckpfosten()
            .filter(
              (p) =>
                // p.anMauer klappt nicht!
                p.ecke?.anMauer
            )
            .forEach((p) => p.reset());
          // Eck- oder Torpfosten müssen noch mal nachgeupdates werden, damit die Höhen der
          // Elemente korrekt berücksichtigt werden
          getTorOderEckpfosten()
            .filter((p) => p.elemente.length > 0)
            .forEach((p) => {
              p.update3d({ mitTorpfostenSonderhöhe: true });
              p.update3dModel();
            });
          this.verschiebeEckpfostenMitUnnötigerLücke();
          if (i == 0) {
            this.updateLichtleisten();
          }
          this.updateWarnungen(trackEmptyChanges, torBreiteMap);
        });

        this.maybeHealEckpfostenLueckeDurchMasselementAnpassung();

        if (!APP.isTorkonfigurator) {
          this.aufbauten.filter((a) => a.isMauer()).forEach((a) => (a.hatKollision = false));
          this.segmente.forEach((s) => s.updateRuler());
        }

        if (!this.nurMasseUpdaten) {
          this.updateAuswahlwerte();
          this.updateStückliste();
          this.ensureSelectedExists();
          this.updateTorAuswahlwerte();
        }
        this.maybeRemoveElementeAusFremderSerie();
      });
      if (!this.nurMasseUpdaten) {
        this.maybeAskElementSeitenwechsel();
        this.maybeAskAnkerInnen();
        this.maybeNotifyPfostenartWechsel(trackPfostenWechsel);
        this.updateAuswahlAccessoren();
      }

      // console.timeEnd("update3d");
    } finally {
      this.INSIDE_ARRANGEMENT_UPDATE3D = false;
    }

    this.setGrundrissEckeWithSegmentEcke();
    APP.trigger("update3d");
  }

  setGrundrissEckeWithSegmentEcke() {
    this.ecken.forEach((ecke) => {
      const grundrissEcken = _.uniq(ecke.segmente.flatMap((s) => s.grundrissKante.ecken));
      const p = Maths3.v3To2xz(ecke.position);
      for (const grundrissEcke of grundrissEcken) {
        const d = grundrissEcke.punkt.distanceTo(p);
        if (d < 0.04) {
          grundrissEcke.segmentEcke = ecke;
          break;
        }
      }
    });
  }

  verschiebeEckpfostenMitUnnötigerLücke() {
    // return;
    // korrigiert die Situation, dass Lücken zwischen Eckpfosten und Elementen entstehen können.
    // Wenn ein Eckpfosten eigentlich gar kein echter Eckpfosten mit mindestens zwei Elementen ist,
    // sondern ein normaler Pfosten, dann gibt es auch keinen Grund, warum er exakt an der Ecke stehen
    // muss. Falls das anliegende Element zur anderen Seite rückt, dann sollte der Pfosten mitrücken.
    // Das ganze wird hier per Nachbehandlung erledigt, und der Pfosten bleibt auch der Ecke zugeordnet.
    // Grund: Die Positionierung der Elemente funktioniert nur, wenn die Eckpfosten wirklich exakt an der
    // Ecke stehen initial. Wegen der Wiederverwendung der Objekte ist es erforderlich, dass der Eckpfosten
    // auch weiter der Ecke zugeordnet ist.
    this.getEckpfosten()
      .filter((pfosten) => pfosten.elemente.length == 1)
      .forEach((pfosten) => {
        const [element] = pfosten.elemente;
        const s = element.segment;
        const eckeIndex = s.ecken.findIndex((ecke) => ecke == pfosten.ecke);
        const [teilLinks, teilRechts] = getLückenTeile(element, pfosten);
        const { abstand, istLücke } = getLückeZwischen(s, teilLinks, teilRechts);
        if (istLücke) {
          const vorzeichen = eckeIndex == 0 ? 1 : -1;
          const delta = s.direction.clone().multiplyScalar(vorzeichen * abstand);
          pfosten.position.add(delta);
        }
      });
  }

  maybeHealEckpfostenLueckeDurchMasselementAnpassung() {
    // return;
    // Speziell bei Eckpfosten kann es passieren, dass ein Pfosten durch den Wechsel eines über Eck anliegenden
    // Elementes auf Tor oder umgekehrt zwischen normalem Pfosten und Torpfosten wechselt. Dadurch würden
    // UMProfile notwendig oder nicht. Anliegende Maßelemente sollten sich anpassen.
    this.getEckpfosten().forEach((pfosten: Pfosten) => {
      pfosten.elemente.forEach((element: ZElement) => {
        const [teilLinks, teilRechts] = getLückenTeile(element, pfosten);
        const segment = element.segment;
        const { abstand, istLücke } = getLückeZwischen(segment, teilLinks, teilRechts);
        if (istLücke) {
          const neueBreite = element.breite + abstand;
          const box = element.sizeRange.flügelBox;
          const schrittweiteX = element.meta?.Mass?.Schrittweite?.x;
          if (
            box.min.x <= neueBreite &&
            neueBreite <= box.max.x &&
            element.meta?.Mass?.Variabel !== "fix"
          ) {
            if (!(schrittweiteX === 0)) {
              const abstandSchrittweite = neueBreite % schrittweiteX;
              element.breite = neueBreite - abstandSchrittweite;
              element.position.x += abstand - abstandSchrittweite;
            } else {
              element.breite = neueBreite;
              element.position.x += abstand;
            }
            // console.log("change element ", element.id, " breite um ", abstand);
          }
        }
      });
    });
  }

  updateEckadapter() {
    // Leider braucht die Eckadapter-Erkennung mindestens 2 update Zyklen, weil
    // im Pfosten.update festgelegt wird, in welchem Winkel Elemente anliegen
    const eckadapterPool = this.lazyPool(this.eckadapter, () => new Eckadapter(null));
    for (const segment of this.segmente) {
      segment.eckadapterDelta[0] = 0;
      segment.eckadapterDelta[1] = 0;
      segment.eckadapter.length = 0;
    }
    for (const element of this.getElemente()) {
      element.eckadapterLinks = null;
      element.eckadapterRechts = null;
    }
    for (const ecke of this.ecken) {
      const pfosten = ecke.pfosten;
      if (!pfosten) {
        continue;
      }
      for (const { element, angle } of pfosten.angles) {
        const segment = element.segment;
        if (!istEckadapter(getAngleIntervalType(pfosten, angle))) {
          continue;
        }
        const eckadapter = eckadapterPool.next();
        segment.eckadapter.push(eckadapter);
        eckadapter.parent = segment;
        eckadapter.ecke = ecke;
        // vorläufige Positionierung
        const { eckadapterMeta, eckadapterDelta, adapterMitte, eckadapterGap } = getEckadapterInfo(
          pfosten.meta as MPfosten
        );
        eckadapter.meta = eckadapterMeta;
        const eckeLinks = segment.ecken[0] === ecke;
        if (eckeLinks) {
          segment.eckadapterDelta[0] = eckadapterDelta;
          eckadapter.position.x = adapterMitte;
          element.eckadapterLinks = eckadapter;
          eckadapter.gapLinks = eckadapterGap;
          eckadapter.gapRechts = 0;
          eckadapter.nachbarLinks = pfosten;
          eckadapter.nachbarRechts = element;
        } else {
          segment.eckadapterDelta[1] = eckadapterDelta;
          eckadapter.position.x = segment.breite - adapterMitte;
          element.eckadapterRechts = eckadapter;
          eckadapter.gapLinks = 0;
          eckadapter.gapRechts = eckadapterGap;
          eckadapter.nachbarLinks = element;
          eckadapter.nachbarRechts = pfosten;
        }
        eckadapter.quaternion.copy(eckeLinks ? Maths3.quaternion.y180 : Maths3.quaternion.zero);
        eckadapter.update3d();
      }
    }
    eckadapterPool.cleanup();
  }

  updateGrundriss() {
    this.grundriss.update3d();
  }

  ensureSelectedExists() {
    const existingObjects = new Set<any>([...this.getPartsAndPfosten(), ...this.aufbauten]);
    this.selectedObjects = this.selectedObjects.filter((o) => existingObjects.has(o));
  }

  updateAuswahlwerte() {
    const elemente = this.getElemente();
    this.abschlussleisteAuswahlwert_ = maxFrequent(
      elemente
        .filter((e) => e.abschlussleisteAuswahlwert != undefined)
        .map((e) => e.abschlussleisteAuswahlwert)
    );
    this.aufsatzleisteAuswahlwert_ = maxFrequent(
      elemente
        .filter((e) => e.aufsatzleisteAuswahlwert != undefined)
        .map((e) => e.aufsatzleisteAuswahlwert)
    );
    this.profilAuswahlwert_ =
      maxFrequent(elemente.map((e) => e.profilAuswahlwert)) ?? this.profilAuswahlwertDefault;
    // Globale Profilposition: Wird explizit gesetzt wenn der User eine Position ändert.
    // Hier nur als Fallback berechnet, wenn noch kein Wert gesetzt wurde.
    if (this.profilPosition_ == null) {
      const elementeMitProfil = elemente.filter((e) => e.showProfil && e.profilPosition != null);
      const positionen = new Set(elementeMitProfil.map((e) => e.profilPosition));
      if (positionen.size === 1) this.profilPosition_ = [...positionen][0];
    }
    this.profilleisteAuswahlwert_ =
      maxFrequent(elemente.map((e) => e.profilleisteAuswahlwert)) ??
      this.profilleisteAuswahlwertDefault;

    const pfosten = this.getPfosten();
    this.pfostenfarbeAuswahlwert_ =
      maxFrequent(pfosten.map((e) => e.pfostenfarbeAuswahlwert)) ??
      this.pfostenfarbeAuswahlwertDefault;
    this.anschlagprofilfarbeAuswahlwert_ =
      maxFrequent(pfosten.map((e) => e.anschlagprofilfarbeAuswahlwert)) ??
      this.anschlagprofilfarbeDefault;
    this.bodenbefestigungAuswahlwert_ =
      maxFrequent(pfosten.map((e) => e.bodenbefestigungAuswahlwert)) ??
      this.bodenbefestigungAuswahlwertDefault;
    this.elementhalterAuswahlwert_ =
      maxFrequent(pfosten.map((e) => e.elementhalterAuswahlwert)) ??
      this.elementhalterAuswahlwertDefault;
    this.updateFüllungAuswahlwert();
  }

  updateFüllungAuswahlwert() {
    this.füllungAuswahlwert = this.selectedObjects.find((p) => p?.isElement)?.füllungAuswahlwert;
  }

  schneideEckenUndSegmente() {
    const lazyPoolEcken = this.lazyPool(this.ecken, () => new Ecke(this));
    const lazyPoolSegmente = this.lazyPool(this.segmente, () => new Segment(this));
    schneideEckenUndSegmente({
      ...this,
      partsAndPfosten: this.getPartsAndPfosten(),
      lazyPoolEcken,
      lazyPoolSegmente,
    });
    this.segmente.forEach((segment) => (segment.updateCounter = 0));
    this.segmente.forEach((segment) => segment.update3d());
  }

  updateParts(elementeBefore: Set<ZElement>) {
    this.segmente.forEach((segment: Segment) => segment.updateParts());

    const elementeAfter = new Set<ZElement>(this.getElemente());
    const anzahlGelöschterElemente = elementeBefore.difference(elementeAfter).size;
    if (anzahlGelöschterElemente > 0 && APP.arrangement.zauneditorVisited) {
      const warnung = I18N(
        "Es wurden %s Elemente oder Tore gelöscht, weil sie zu weit aus der Grundstücksgrenze ragen",
        anzahlGelöschterElemente
      );
      console.warn(warnung);
      if (!useAlertForDialogs) {
        Dialogs.showToast(warnung, { type: "warning" });
      }
    }
  }

  updateEckpfosten() {
    // Die Eckpfosten müssen vor den Elemente bekannt sein, da Eckadapter den verbleibenden
    // Platz der Segmente verändern. Daher wird hier der Zuweisung der Elemente zu den Eckpfosten
    // und der anliegenden Winkel vorgegriffen, und später abschließend noch mal in der
    // Segment.insertPfosten sowie Pfosten.update3d ausgeführt.

    this.ecken.forEach((ecke: Ecke) => {
      const elemente = getVorläufigeElementeAnEcke(ecke).filter((element) => element != null);
      const pfosten = ecke.pfosten;
      if (pfosten == null) return;
      elemente.filter((e) => e.meta == null).forEach((e) => e.updateMetas());
      pfosten.elemente = elemente;
      pfosten.angles = getPfostenWinkelListe(pfosten, elemente);
    });

    this.getEckpfosten().forEach((pfosten: Pfosten) => {
      if (pfosten.elemente.length == 0 || pfosten.anMauer) {
        // ein Pfosten ohne Elemente wird abgeräumt
        // pfosten.reset();
        if (pfosten.ecke != null) {
          pfosten.ecke.gelöschterPfosten = pfosten;
          pfosten.ecke.pfosten = null;
        }
        pfosten.ecke = null;
        pfosten.elemente = [];
        return;
      }
      pfosten.position.copy(pfosten.position);
      // Eckpfosten werden evtl. mehrfach geupdated
      // Achtung: Dieses Update hier kommt vor dem Element-Update!
      pfosten.update3d();
      // aber update3dModel darf nur einmal aufgerufen werden
      pfosten.update3dModel();
      pfosten.nachbarLinks = null;
      pfosten.nachbarRechts = null;
      pfosten.gapLinks = 0;
      pfosten.gapRechts = 0;
    });
  }

  selectAllParts() {
    this.setSelectedObjects(
      this.getParts()
        .concat(this.aufbauten)
        .filter((e) => !e.isEmpty)
    );
  }

  selectAllPfosten() {
    this.setSelectedObjects(this.getPfosten());
  }

  async removeSelectedObjects() {
    const selectedObjects = this.selectedObjects.filter((e) => !e.isPfosten);
    if (selectedObjects.length == 0) {
      return;
    } else if (selectedObjects.length > 2) {
      await APP.showSpinner();
    }

    APP.logUserAction({ action: "removeSelectedObjects" });

    const newSelected = [];
    const [aufbauten, elements] = Commons.partition(selectedObjects, (o) => o.isAufbau);
    if (aufbauten.length > 0) {
      this.uiRemoveAufbauten(aufbauten);
    }

    const isEmpty = selectedObjects[0].isEmpty;
    if (APP.settings.fadeOutDeletedElements) {
      const setTransition = (element, callback) => {
        element.transition = {
          duration: 1000,
          delay: 0,
          property: "all",
        };
        element.opacity = 0;
        element.scale.set(1, 0, 1);

        return callback();
      };
      const promises = elements.map((element) => {
        return new Promise((resolve) => {
          const segment = element.segment;
          const x = segment.getX(element, 0.5);

          setTransition(element, () =>
            setTimeout(() => {
              element.uiRemove();
              this.update3d();
              !isEmpty && newSelected.push(segment.getPartAtPositionX(x));

              resolve(undefined);
            }, 1000)
          );
        });
      });
      APP.dirty();
      await Promise.all(promises);
    } else {
      elements.forEach((element) => {
        const segment = element.segment;
        const x = segment.getX(element, 0.5);
        element.uiRemove();
        this.update3d();
        !isEmpty && newSelected.push(segment.getPartAtPositionX(x));
      });
    }
    if (
      Commons.isEmpty(this.selectedObjects) ||
      Commons.arraysEqual(selectedObjects, this.selectedObjects)
    ) {
      // nur setzen, falls der User nicht zwischenzeitlich was anderes selektiert hat
      this.setSelectedObjects(newSelected);
    }
    APP.dirty();

    APP.hideSpinner();
  }

  /**
   * löscht Aufbauten so, dass anliegende Elemente an ihrer Position stehen bleiben
   * @param aufbauten
   */
  uiRemoveAufbauten(aufbauten: Aufbau[]) {
    // Lösche die Aufbauten
    this.aufbauten = this.aufbauten.filter((a) => !aufbauten.includes(a));
    // Setze den snap aller Elemente, die an den gelöschten Aufbauten standen, auf 0 (also fixiere sie an ihrer Position)
    const eckenAnAufbauten = this.ecken.filter((e) =>
      e.aufbauten.some((a) => aufbauten.includes(a))
    );
    for (let ecke of eckenAnAufbauten) {
      for (const segment of ecke.segmente) {
        const side = segment.findClosestSideToWorldPosition(ecke.position);
        const parts = segment.parts.filter(
          (p) => p.isElement || (p.isEmpty && !p.automatischeBreite)
        );
        const partAnEcke = parts.at(side == 0 ? 0 : -1);
        const partXAnEcke = segment.getX(partAnEcke, side);
        const partWPAnEcke = segment.getWorldPositionOfX(partXAnEcke);
        if (partWPAnEcke.distanceTo(ecke.position) < 0.1) {
          partAnEcke.snap = 0;
        }
      }
    }
    // Speichere die Worldposition aller Parts,
    // vereinige die Segmente,
    // und stelle die ursprüngliche Worldposition wieder her
    const getWorldPosition = (part: Part) => {
      const segment = part.segment;
      return segment.getWorldPositionOfX(segment.getX(part, 0.5));
    };
    const setWorldPosition = (part: Part, wp: Vector3) => {
      const segment = part.segment;
      const x = segment.getXOfWorldPosition(wp);
      return segment.setX(part, 0.5, x);
    };
    const partsInSegments = this.getParts().filter((p) => !p.isEckpfosten);
    const partWorldPositionList = partsInSegments.map((part) => ({
      part,
      worldPosition: getWorldPosition(part),
    }));
    this.schneideEckenUndSegmente();
    partWorldPositionList.forEach(({ part, worldPosition }) =>
      setWorldPosition(part, worldPosition)
    );
    this.update3d();
  }

  changeZaunElemente(
    {
      massAuswahlwert = undefined,
      füllungAuswahlwert = undefined,
      size = undefined,
      seiteGewechselt = undefined,
      profilAuswahlwert = undefined,
      maximumNumberOfElements = undefined,
      schaffePlatzFallsDoppeltor = true,
    }: Partial<{
      massAuswahlwert: MAuswahlwert;
      füllungAuswahlwert: MAuswahlwert;
      size: Vector2;
      seiteGewechselt: boolean;
      profilAuswahlwert: MAuswahlwert;
      maximumNumberOfElements: number;
      schaffePlatzFallsDoppeltor: boolean;
    }>,
    parts: any[]
  ) {
    if (massAuswahlwert == null && füllungAuswahlwert == null && profilAuswahlwert == null) {
      // sollte nicht vorkommen
      debugger;
    }

    let alleElemente = parts.length == 0;
    if (alleElemente) {
      parts = this.getElemente();
    }

    let elementsChanged = [];
    parts.forEach((p) => {
      let part = p;
      if (part.isAufbau) return;
      const isDoppeltor = massAuswahlwert?.Mass?.[0]?.Tor?.some((t) => t?.Doppeltor);
      const isSchiebetor = isSchiebetorForm(massAuswahlwert?.Mass?.[0]?.Form);
      const isEmptyMitMinimalbreiteFürDoppeltor =
        part.isEmpty && part.breite >= APP.settings.MinimalbreiteLeerraumDoppeltor;
      const isEmptyMitMinimalbreiteFürSchiebetor =
        part.isEmpty && part.breite >= APP.settings.MinimalbreiteLeerraumSchiebetor;
      if (schaffePlatzFallsDoppeltor && isDoppeltor && !isEmptyMitMinimalbreiteFürDoppeltor) {
        // Wir löschen - wenn nötig - sowohl das Nachbarelement als auch unser selektiertes
        // Element und müssen dann im Anschluss den neu entstandenen Leerraum als part weiterreichen
        const segment = part?.segment;
        const x = segment.getX(part, 0.5);
        löscheNachbarElementeUmMindestplatzZuErreichen(part, 3.5);
        part = segment.getPartAtPositionX(x);
      }
      if (schaffePlatzFallsDoppeltor && isSchiebetor && !isEmptyMitMinimalbreiteFürSchiebetor) {
        // Analog zum Doppeltor, aber beim Schiebetor werden 2 Nachbarelemente gelöscht,
        // da ein Schiebetor deutlich mehr Platz benötigt
        const segment = part?.segment;
        const x = segment.getX(part, 0.5);
        löscheNachbarElementeUmMindestplatzZuErreichen(
          part,
          APP.settings.MinimalbreiteLeerraumSchiebetor
        );
        part = segment.getPartAtPositionX(x);
      }
      if (part.isEmpty) {
        let addedElements;
        if (massAuswahlwert === undefined && size === undefined) {
          const element = this.createDefaultElement({
            füllungAuswahlwert,
          });
          addedElements = part.fillWithElements(element, {
            allowMassElement: true,
            minimalOneElement: true,
          });
        } else {
          addedElements = this.ghostPool.withPool(() => {
            const element = this.createElement({
              massAuswahlwert,
              füllungAuswahlwert,
              size,
              seiteGewechselt,
              profilAuswahlwert,
            });
            if (massAuswahlwert.Key === "Doppeltor_Easy") {
              this.maybeSetBodenbefestigungEinbetoniert(part);
            }
            return part.fillWithElements(element, {
              minimalOneElement: true,
              allowMassElement: element.isBreiteVariabel,
              allowToGrowToMaximum: false,
              maximumNumberOfElements,
            });
          });
        }
        elementsChanged = elementsChanged.concat(addedElements);
      } else {
        part.change({
          massAuswahlwert,
          füllungAuswahlwert,
          size,
          seiteGewechselt,
          profilAuswahlwert,
          individualisiert: !alleElemente,
        });
        // Wenn Elemente aus der Elementleiste eingefügt werden, kann es vorkommen, dass sowohl
        // massAuswahlwert als auch füllungAuswahlwert gesetzt werden. In dem Fall findet keine
        // Individualisierung des füllungAuswahlwertes statt
        const massAuswahlwertUndefined = massAuswahlwert === undefined;
        massAuswahlwertUndefined && this.showAuswahlwertIndividualisiertInfo([füllungAuswahlwert]);
        if (profilAuswahlwert) {
          this.showAuswahlwertIndividualisiertInfo([profilAuswahlwert]);
          part.showIndividualisiert = true;
          this.recentlyIndividualisiertAuswahlwert = "profilAuswahlwert";
        } else {
          part.showIndividualisiert = true;
          this.recentlyIndividualisiertAuswahlwert = "füllungAuswahlwert";
        }
        elementsChanged = elementsChanged.concat([part]);
      }
      part.segment.repositionAndCheckSnaps();
      part.segment.korrigiereFalscheDreifachtore();
      part.segment.korrigiereEinzeltorAnSchiebetor();
      // part.segment.logit();
    });
    this.update3d();
    if (!alleElemente && _.sum(elementsChanged.filter((a: ZElement) => a?.size?.x > 0))) {
      this.setSelectedObjects(elementsChanged);
    }

    if (füllungAuswahlwert !== undefined) {
      this.füllungAuswahlwert = füllungAuswahlwert;
      this.getSelectedOrAllElemente().forEach((element) => {
        element.abschlussleisteAuswahlwert = null;
        element.abschlussleisteAuswahlwertIndividualisiert = false;
      });
    }
  }

  changePfosten(
    {
      pfostenfarbeAuswahlwert = undefined,
      ankerAuswahlwert = undefined,
      bodenbefestigungAuswahlwert = undefined,
      ankerInnen = undefined,
      pfostenartAuswahlwert = undefined,
      elementhalterAuswahlwert = undefined,
      ummantelungAuswahlwert = undefined,
      montageadapterAuswahlwert = undefined,
      verbundankerAuswahlwert = undefined,
      pfostenkappeAuswahlwert = undefined,
    }: Partial<{
      pfostenfarbeAuswahlwert: MAuswahlwert;
      ankerAuswahlwert: MAuswahlwert;
      bodenbefestigungAuswahlwert: MAuswahlwert;
      ankerInnen: MAuswahlwert;
      pfostenartAuswahlwert: MAuswahlwert;
      elementhalterAuswahlwert: MAuswahlwert;
      ummantelungAuswahlwert: MAuswahlwert;
      montageadapterAuswahlwert: MAuswahlwert;
      verbundankerAuswahlwert: MAuswahlwert;
      pfostenkappeAuswahlwert: MAuswahlwert;
    }>,
    selectedPfosten: Pfosten[] = []
  ) {
    if (
      pfostenfarbeAuswahlwert == null &&
      ankerAuswahlwert == null &&
      bodenbefestigungAuswahlwert == null &&
      ankerInnen == null &&
      pfostenartAuswahlwert == null &&
      elementhalterAuswahlwert == null &&
      ummantelungAuswahlwert == null &&
      montageadapterAuswahlwert == null &&
      verbundankerAuswahlwert == null &&
      pfostenkappeAuswahlwert == null
    ) {
      // sollte nicht vorkommen
      debugger;
    }

    if (pfostenartAuswahlwert != null) {
      this.mostRecentPfostenart = pfostenartAuswahlwert;
      if (selectedPfosten.length == 0) {
        this.pfostenartAuswahlwert = pfostenartAuswahlwert;
      }
    }

    if (this.pfostenfarbeAuswahlwert != pfostenfarbeAuswahlwert) {
      const part = this.getParts().find((p: any) => p.eAntriebHinweis);
      if (part) {
        Dialogs.showToast(part.eAntriebHinweis);
      }
    }

    if (
      bodenbefestigungAuswahlwert != null &&
      this.bodenbefestigungAuswahlwert != bodenbefestigungAuswahlwert
    ) {
      this.mostRecentBodenbefestigung = bodenbefestigungAuswahlwert;
    }

    if (ummantelungAuswahlwert?.Key == "Ummantelung_mit") {
      this.maybeShowUmmantelungWarnung = true;
    }

    const pfosten = selectedPfosten.length == 0 ? this.getPfosten() : selectedPfosten;
    const pfostenSindSelektiert = selectedPfosten.length > 0;
    const ermittleAktuellIndividualisiertePfosten = () =>
      new Set(pfosten.filter((p) => p.hasIndividualisierteAuswahlwerte));
    const zuvorSchonIndividualisiert = ermittleAktuellIndividualisiertePfosten();

    pfosten
      .filter((p) => p.isPfosten)
      .forEach((p) => {
        if (
          pfostenfarbeAuswahlwert &&
          (pfostenSindSelektiert ||
            !p.pfostenfarbeAuswahlwertIndividualisiert ||
            this.isAllPartsIndividualisiert(
              this.getPfosten(),
              "pfostenfarbeAuswahlwertIndividualisiert"
            ))
        ) {
          p.pfostenfarbeAuswahlwert = pfostenfarbeAuswahlwert;
          if (pfostenSindSelektiert) {
            p.pfostenfarbeAuswahlwertIndividualisiert =
              this.pfostenfarbeAuswahlwert_ != pfostenfarbeAuswahlwert;
            p.showIndividualisiert = true;
            this.recentlyIndividualisiertAuswahlwert = "pfostenfarbeAuswahlwert";
          }
        }
        if (
          pfostenartAuswahlwert &&
          (pfostenSindSelektiert ||
            !p.pfostenartAuswahlwertIndividualisiert ||
            this.isAllPartsIndividualisiert(
              this.getPfosten(),
              "pfostenartAuswahlwertIndividualisiert"
            ))
        ) {
          p.pfostenartAuswahlwert = pfostenartAuswahlwert;
          if (pfostenSindSelektiert) {
            p.pfostenartAuswahlwertIndividualisiert =
              this.pfostenartAuswahlwert != pfostenartAuswahlwert;
            p.showIndividualisiert = true;
            this.recentlyIndividualisiertAuswahlwert = "pfostenartAuswahlwert";
          }
        }
        if (ankerAuswahlwert) {
          p.ankerAuswahlwert = ankerAuswahlwert;
        }
        if (
          bodenbefestigungAuswahlwert &&
          (pfostenSindSelektiert ||
            !p.bodenbefestigungAuswahlwertIndividualisiert ||
            this.isAllPartsIndividualisiert(
              this.getPfosten(),
              "bodenbefestigungAuswahlwertIndividualisiert"
            ))
        ) {
          p.bodenbefestigungAuswahlwert = bodenbefestigungAuswahlwert;
          if (pfostenSindSelektiert) {
            p.bodenbefestigungAuswahlwertIndividualisiert =
              this.bodenbefestigungAuswahlwert_ != bodenbefestigungAuswahlwert;
            p.showIndividualisiert = true;
            this.recentlyIndividualisiertAuswahlwert = "bodenbefestigungAuswahlwert";
          }
        }
        if (ankerInnen != null) {
          p.ankerInnen = true;
        }
        if (
          elementhalterAuswahlwert &&
          (pfostenSindSelektiert ||
            !p.elementhalterAuswahlwertIndividualisiert ||
            this.isAllPartsIndividualisiert(
              this.getPfosten(),
              "elementhalterAuswahlwertIndividualisiert"
            ))
        ) {
          p.elementhalterAuswahlwert = elementhalterAuswahlwert;
          if (pfostenSindSelektiert) {
            p.elementhalterAuswahlwertIndividualisiert =
              this.elementhalterAuswahlwert_ != elementhalterAuswahlwert;
            p.showIndividualisiert = true;
            this.recentlyIndividualisiertAuswahlwert = "elementhalterAuswahlwert";
          }
        }
        if (montageadapterAuswahlwert) {
          p.montageadapterAuswahlwert = montageadapterAuswahlwert;
        }
        if (verbundankerAuswahlwert) {
          p.verbundankerAuswahlwert = verbundankerAuswahlwert;
        }
        if (ummantelungAuswahlwert) {
          p.ummantelungAuswahlwert = ummantelungAuswahlwert;
        }
        if (pfostenkappeAuswahlwert) {
          p.pfostenkappeAuswahlwert = pfostenkappeAuswahlwert;
        }
      });

    if (pfostenartAuswahlwert != null) {
      this.updatingPfostenart = true;
    }
    if (pfostenSindSelektiert) {
      const neuIndividualisiert = ermittleAktuellIndividualisiertePfosten().difference(
        zuvorSchonIndividualisiert
      );
      if (neuIndividualisiert.size > 0) {
        this.showAuswahlwertIndividualisiertInfo([
          pfostenfarbeAuswahlwert,
          bodenbefestigungAuswahlwert,
          pfostenartAuswahlwert,
          elementhalterAuswahlwert,
        ]);
      }
    }

    this.update3d();

    if (pfostenartAuswahlwert != null) {
      this.updatingPfostenart = false;
    }
  }

  showAuswahlwertIndividualisiertInfo(auswahlwerte: MAuswahlwert[]) {
    if (APP?.isTorkonfigurator || APP?.pageIndex != 1) return;
    auswahlwerte.forEach(
      (auswahlwert) =>
        auswahlwert &&
        auswahlwert.Auswahl.Key !== "Füllung" &&
        Dialogs.showToast(
          I18N("%s der selektierten Parts wurde individualisiert.", auswahlwert.Auswahl.Key),
          { delay: 6000 }
        )
    );
  }

  resetIndividualisierteAuswahlwerte() {
    const pfostenAuswahlwerte = [
      "pfostenfarbeAuswahlwertIndividualisiert",
      "bodenbefestigungAuswahlwertIndividualisiert",
      "pfostenartAuswahlwertIndividualisiert",
      "elementhalterAuswahlwertIndividualisiert",
    ];
    const elementAuswahlwerte = [
      "füllungAuswahlwertIndividualisiert",
      "abschlussleisteAuswahlwertIndividualisiert",
      "profilAuswahlwertIndividualisiert",
      "profilPositionIndividualisiert",
    ];
    this.getPartsAndPfosten().forEach((p) => {
      if (p.isPfosten) {
        pfostenAuswahlwerte.forEach((auswahlwert) => {
          p[auswahlwert] = false;
        });
      } else if (p.isElement) {
        elementAuswahlwerte.forEach((auswahlwert) => {
          p[auswahlwert] = false;
        });
      }
    });
    APP.dirty();
  }

  toggleShowIndividualisierteAuswahlwerte(on: boolean) {
    this.showAllIndividualisiert = on;
    APP.dirty();
  }

  isAllPartsIndividualisiert(parts: any, key: string): boolean {
    return parts.every((p) => p[key]);
  }

  removeSelectedMauern(uiRemove = true) {
    let mauern;
    [mauern, this.selectedObjects] = Commons.partition(this.selectedObjects, (p) => p.isMauer);
    if (mauern.length > 0) {
      const getEmptiesSet = () => new Set(this.getEmpties());
      const leerraeumeVorher = getEmptiesSet();
      if (uiRemove) {
        this.uiRemoveAufbauten(mauern);
      } else {
        this.aufbauten = this.aufbauten.filter((a) => !mauern.includes(a));
        this.update3d();
      }
      const mauernEmpties = getEmptiesSet().difference(leerraeumeVorher);
      this.selectedObjects.push(...mauernEmpties);
    }
  }

  async changeSelectedZaunElemente(options: any) {
    this.removeSelectedMauern(false);

    if (this.selectedObjects.length > 0) {
      const segmente = new Set(
        this.selectedObjects.filter((o) => !o.isPfostenAnEcke).map((o) => o.segment)
      ).toArray();
      segmente.forEach((s) => s.setVerteilungsmodusIndividuell());
    }

    this.changeZaunElemente(options, this.selectedObjects);
    APP.dirty();
    await Commons.sleep(10);
    // die Auswahl-Linien den Kreismenus erfordern eine Wartezeit...
    APP.updateUI();
    APP.trigger("changeZaunelement");
  }

  async changeSelectedPfosten(options: any) {
    const pfosten = APP.isTorkonfigurator ? this.getPfosten() : this.selectedObjects;
    this.changePfosten(options, pfosten);
    APP.dirty();
    await Commons.sleep(10);
    // die Auswahl-Linien den Kreismenus erfordern eine Wartezeit...
    APP.updateUI();
    APP.trigger("changeZaunelement");
  }

  testVierfachtor = (tore: ZElement[]) => {
    return tore.some(
      (tor) =>
        tor
          .getSegmentNachbarn()
          .filter((n) => n && !tore.includes(n as ZElement) && (n as ZElement).isTor).length > 0
    );
  };

  getSchiebetorEinzeltorKombi(tore: ZElement[]) {
    const [schiebetor, einzeltor] = Commons.partition(tore, (t) => t.isSchiebetor).map((a) => a[0]);
    const einzeltorLinks = einzeltor.position.x < schiebetor.position.x;
    return { schiebetor, einzeltor, einzeltorLinks };
  }

  getSchiebetorDoppeltorKombi(tore: ZElement[]) {
    const [schiebetor, tor] = Commons.partition(tore, (t) => t.isSchiebetor).map((a) => a[0]);
    return tor.isDoppeltor;
  }

  testSchiebetorFalscherAnschlag(tore: ZElement[]) {
    const { schiebetor, einzeltor, einzeltorLinks } = this.getSchiebetorEinzeltorKombi(tore);
    return einzeltor.isEinzeltor && einzeltor.isAufhängungAnLinkerTorseite != einzeltorLinks;
  }

  testSchiebetorFalscheSeite(tore: ZElement[]) {
    const { schiebetor, einzeltor, einzeltorLinks } = this.getSchiebetorEinzeltorKombi(tore);
    const schieberichtungRechts =
      schiebetor.schieberichtungAuswahlwert.Key == "Schieberichtung_rechts";
    return einzeltor.isEinzeltor && einzeltorLinks == schieberichtungRechts;
  }

  /**
   * Sind die beiden gegebenen Tore ein ungültiges Dreifachtor (wegen falschem Anschlag Einzeltor)?
   * @param tore zwei angrenzende Tore
   * @returns {boolean|*}
   */
  testDreifachtorFalscherAnschlag = (tore: ZElement[]): boolean => {
    if (!tore.some((tor) => tor.isDoppeltor)) {
      return false;
    }
    if (tore[0].isÖffnungNachInnen == tore[1].isÖffnungNachInnen) {
      const [left, right] = _.sortBy(tore, (t) => t.position.x);
      return (
        (!left.isAufhängungAnLinkerTorseite || left.isDoppeltor) &&
        (right.isAufhängungAnLinkerTorseite || right.isDoppeltor)
      );
    }
    return false;
  };

  updateWarnungen(lastIdEmptyBreiteMap: Map<number, number>, torBreiteMap: Map<ZElement, number>) {
    const hideWarnungenFürTorkonf =
      APP.isTorkonfigurator && APP.optionMenu?.getCurrentKey() != "Abschluss";
    if (APP.hideWarnungen || hideWarnungenFürTorkonf) {
      return;
    }
    const warnungenPool = this.lazyPool(this.warnungen, () => new Warnung(this));
    const getOBBWorld = (o: Jaco) => o.getOBBWorld();
    const warningStackStepY = 0.3;
    const warningStackIndexByTargetId = new Map<number, number>();
    const warningStackIndexByLocation = new Map<string, number>();

    const isWarnungZylinderSektor = (
      geometry: OBB | WarnungZylinderSektor
    ): geometry is WarnungZylinderSektor =>
      (geometry as WarnungZylinderSektor)?.type === "zylindersektor";

    const getWarningTargetIds = (jacos: Jaco[]) =>
      (jacos ?? [])
        .filter((jaco) => jaco != null && !(jaco as any).isWarnung && jaco.id != null)
        .map((jaco) => jaco.id)
        .sort((a, b) => a - b);

    const getWarningLocationKey = (obb: OBB) => {
      const { x, y, z } = obb.center;
      const c = [x, y, z].map((value) => Math.round(value * 100) / 100).join("_");
      return "obb:" + c;
    };

    const getWarningStackIndex = (obb: OBB, jacos: Jaco[]) => {
      if (APP.isTorkonfigurator) {
        return 0;
      }
      const targetIds = getWarningTargetIds(jacos);
      if (targetIds.length > 0) {
        return targetIds.reduce(
          (max, id) => Math.max(max, warningStackIndexByTargetId.get(id) ?? 0),
          0
        );
      }
      const key = getWarningLocationKey(obb);
      return warningStackIndexByLocation.get(key) ?? 0;
    };

    const reserveWarningStackSlot = (stackIndex: number, obb: OBB, jacos: Jaco[]) => {
      const targetIds = getWarningTargetIds(jacos);
      if (targetIds.length > 0) {
        targetIds.forEach((id) => warningStackIndexByTargetId.set(id, stackIndex + 1));
        return;
      }
      const key = getWarningLocationKey(obb);
      warningStackIndexByLocation.set(key, stackIndex + 1);
    };

    const addWarning = (
      geometry: OBB | WarnungZylinderSektor,
      text: string,
      jacos: Jaco[],
      dialogKey: WarnungDialogKey,
      matrix = new Matrix4(),
      extraYOffset = 0
    ) => {
      if (isWarnungDialogSuppressed(dialogKey)) {
        return;
      }
      const warnung = warnungenPool.next();
      const stackGeometry = isWarnungZylinderSektor(geometry) ? getOBBWorld(jacos[0]) : geometry;
      const stackIndex = getWarningStackIndex(stackGeometry, jacos);
      reserveWarningStackSlot(stackIndex, stackGeometry, jacos);

      warnung.text = text;
      warnung.jacos = jacos;
      warnung.wichtigkeit = getWarnungWichtigkeitByKey(dialogKey);
      warnung.positionYOffset = stackIndex * warningStackStepY + extraYOffset;
      warnung.dialogConfig = createWarnungDialogConfig({
        arrangement: this,
        key: dialogKey,
        text,
        jacos,
      });
      if (isWarnungZylinderSektor(geometry)) {
        warnung.box3OrOBB = geometry;
      } else {
        const o = 0.01;
        if (!warnung.box3OrOBB || typeof warnung.box3OrOBB.copy !== "function") {
          warnung.box3OrOBB = new OBB();
        }
        warnung.box3OrOBB.copy(geometry).expandByVector(v3(o, o, o));
      }
      warnung.copyMatrix(matrix);
    };

    const parts = this.getPartsAndPfosten().filter((a) => !a.isEmpty);
    const boxEpsilon = v3(1, 1, 1).multiplyScalar(-0.001);
    const collisions = Collisions.bruteForceOBBoxCollisions(parts, {
      // ein kleines Epsilon wird von der Box abgezogen, damit genau aneinanderliegende Boxen ignoriert werden
      localBox3Getter: (o) => o.getBox().expandByVector(boxEpsilon),
      matrixWorldGetter: (o) => o.matrixWorld,
      accept: (a, b) =>
        // die Kollision zweier Elemente wird an anderer Stelle geprüft, denn sie bringt hier in spitzen Ecksituationen Probleme
        (a.isPfosten && b.isPfosten) || (a.isMauer || a.isEmpty) != (b.isMauer || b.isEmpty),
    });
    collisions.forEach(([a, b]) => {
      const intersection = getOBBWorld(a).intersect(getOBBWorld(b));
      if (intersection) {
        const erweiterung = v3(1, 1, 1).multiplyScalar(0.05);
        return addWarning(
          intersection.expandByVector(erweiterung),
          I18N("warnung::Kollision zweier Teile"),
          [a, b],
          WARNUNG_DIALOG_KEYS.KOLLISIONEN
        );
      }
    });
    if (collisions.length > 0) {
      console.warn("Collisions", collisions);
    }

    // Kollision zwischen Mauer-Aufbauten und Pfosten-Fundamenten sowie Schiebetor-Fundamenten
    if (!APP.isTorkonfigurator) {
      const mauerAufbauten = this.aufbauten.filter((a) => a.isMauer());
      const fundamente = this.getFundamente();
      for (const mauer of mauerAufbauten) {
        const mauerOBB = getOBBWorld(mauer);
        for (const fundament of fundamente) {
          const fundamentOBB = getOBBWorld(fundament);
          if (mauerOBB.intersect(fundamentOBB)) {
            const extraYOffset = fundamentOBB.grid(0, 0, 0).y - 1;
            addWarning(
              fundamentOBB,
              I18N("warnung::Mauer kollidiert mit Fundament"),
              [mauer, fundament],
              WARNUNG_DIALOG_KEYS.MAUER_KOLLIDIERT_MIT_FUNDAMENT,
              new Matrix4(),
              extraYOffset
            );
          }
        }
      }
    }

    const klobenAndElemente = this.getElemente()
      .filter((e) => e.isTor)
      .map((tor) => ({
        klobenListe: tor.getKloben(),
        elementListe:
          tor
            ?.getTorpfosten()
            ?.filter((p) => p.isPfostenAnEcke)
            ?.flatMap((p) => p.elemente.filter((e) => e !== tor)) ?? [],
      }));
    let klobenCollisionPfosten = new Set();
    const collides = (jacos: any[]) =>
      Collisions.bruteForceOBBoxCollisions(jacos, {
        localBox3Getter: (o) => o.getBox(),
        matrixWorldGetter: (o) => o.matrixWorld,
      });
    klobenAndElemente.forEach(({ klobenListe, elementListe }, index) => {
      for (const kloben of klobenListe) {
        outer: for (const element of elementListe) {
          const kollisionsTeile = [
            element,
            element.umprofilLinks,
            element.umprofilRechts,
            // Eckadapter ignorieren wir vorerst
            // element.eckadapterLinks,
            // element.eckadapterRechts,
          ].filter((e) => e != null);
          for (const teil of kollisionsTeile) {
            const coll = collides([kloben, teil]);
            if (coll.length > 0) {
              klobenCollisionPfosten.add((kloben as any).pfosten);
              break outer;
            }
          }
        }
      }
    });
    const eckpfostenMitDoppeltenToren = new Set<Pfosten>(
      this.getEckpfosten().filter((p) => p.elemente.filter((e) => e.isTor).length >= 2)
    );

    eckpfostenMitDoppeltenToren.forEach((p) =>
      addWarning(
        getOBBWorld(p),
        I18N("Es dürfen keine zwei Tore an einem Eckpfosten stehen"),
        [p],
        WARNUNG_DIALOG_KEYS.ECKPFOSTEN_ZWEI_TORE
      )
    );

    klobenCollisionPfosten
      .filter((p) => !eckpfostenMitDoppeltenToren.has(p as Pfosten))
      .forEach((pfosten) =>
        addWarning(
          getOBBWorld(pfosten as Pfosten),
          I18N("torEckpfostenOeffnung"),
          [pfosten as Pfosten],
          WARNUNG_DIALOG_KEYS.TOR_ECKPFOSTEN_OEFFNUNG
        )
      );

    this.getPfosten()
      .filter((p) => !p.isPfostenAnEcke)
      .forEach((p) => {
        const tore = p.elemente.filter((e) => e.isTor);
        const einzeltore = tore.filter((e) => e.isEinzeltor).length;
        const doppeltore = tore.filter((e) => e.isDoppeltor).length;
        const schiebetore = tore.filter((e) => e.isSchiebetor).length;
        if (tore.length == 2) {
          if (schiebetore == 2) {
            addWarning(
              getOBBWorld(p),
              I18N("Es dürfen keine zwei Schiebetore nebeneinander stehen"),
              [p],
              WARNUNG_DIALOG_KEYS.ZWEI_SCHIEBETORE_NEBENEINANDER
            );
          }
          if (einzeltore == 2) {
            addWarning(
              getOBBWorld(p),
              I18N("Es dürfen keine zwei Einzeltore nebeneinander stehen"),
              [p],
              WARNUNG_DIALOG_KEYS.ZWEI_EINZELTORE_NEBENEINANDER
            );
          }
          if (doppeltore == 2) {
            addWarning(
              getOBBWorld(p),
              I18N("Es dürfen keine zwei Doppeltore nebeneinander stehen"),
              [p],
              WARNUNG_DIALOG_KEYS.ZWEI_DOPPELTORE_NEBENEINANDER
            );
          }
          if (this.testVierfachtor(tore)) {
            addWarning(
              getOBBWorld(p),
              I18N("Es dürfen keine drei Tore nebeneinander stehen"),
              [p],
              WARNUNG_DIALOG_KEYS.DREI_BENACHBARTE_TORE
            );
          }
          if (tore.some((t) => t.isEAntrieb && t.isDoppeltor)) {
            addWarning(
              getOBBWorld(p),
              I18N("Doppeltore mit E-Antrieb haben einen seitlichen Sperrbereich von 11cm"),
              [p],
              WARNUNG_DIALOG_KEYS.E_ANTRIEB_KOLLISION
            );
          }
          if (schiebetore == 1 && this.testSchiebetorFalscherAnschlag(tore)) {
            addWarning(
              getOBBWorld(p),
              I18N("Anschlag kollidiert mit Nachbarelement"),
              [p],
              WARNUNG_DIALOG_KEYS.SCHIEBETOR_ANSCHLAG_KOLLISION
            );
          } else if (schiebetore == 1 && this.getSchiebetorDoppeltorKombi(tore)) {
            addWarning(
              getOBBWorld(p),
              I18N("Schiebetore und Doppeltore dürfen nicht nebeneinander stehen."),
              [p],
              WARNUNG_DIALOG_KEYS.SCHIEBETOR_DOPPELTOR_NACHBARN
            );
          } else if (schiebetore == 1 && this.testSchiebetorFalscheSeite(tore)) {
            addWarning(
              getOBBWorld(p),
              I18N("An der Öffnungsrichtung des Schiebetores darf kein anderes Tor sein"),
              [p],
              WARNUNG_DIALOG_KEYS.SCHIEBETOR_ÖFFNUNGSRICHTUNG_TORKOLLISION
            );
          }
          if (this.testDreifachtorFalscherAnschlag(tore)) {
            addWarning(
              getOBBWorld(p),
              I18N("Anschlag kollidiert mit Nachbarelement"),
              [p],
              WARNUNG_DIALOG_KEYS.DREIFACHTOR_ANSCHLAG_KOLLISION
            );
          }
        }
        if (tore.some((t) => t.isEAntrieb && t.isDoppeltor)) {
          const isPfostenLinks = tore.find((t) => t.isEAntrieb).pfostenLinks == p;
          const segment = p.parent as Segment;
          const posX = segment.getX(p, isPfostenLinks ? 0 : 1);
          const distanceToSegmentEnde = isPfostenLinks ? posX : segment.breite - posX;
          if (distanceToSegmentEnde < 0.12) {
            const boxWorld = getOBBWorld(p);
            // Damit die Warnung noch sichtbar ist, wenn das Tor direkt neben einer Mauer steht
            if (boxWorld.halfSize.y < 0.5) {
              boxWorld.halfSize.y = 2;
            }
            addWarning(
              boxWorld,
              I18N("Doppeltore mit E-Antrieb haben einen seitlichen Sperrbereich von 11cm"),
              [p],
              WARNUNG_DIALOG_KEYS.E_ANTRIEB_KOLLISION
            );
          }
        }
      });
    const isTest = new URL(document.location.href).searchParams.has("test");

    if (this.mostRecentPfostenart && (!APP.messages?.state.hidden || isTest)) {
      const unveraendertePfosten = this.getSelectedOrAllPfosten().filter(
        (p) =>
          !p.pfostenartAuswahlwertIndividualisiert &&
          (p.meta as MPfosten)?.Pfostenart &&
          this.mostRecentPfostenart !== (p.meta as MPfosten)?.Pfostenart?.[0].Auswahlwert
      );
      if (unveraendertePfosten.length > 0) {
        Dialogs.showToast(I18N("Die Pfostenart der markierten Pfosten ist unveränderlich!"), {
          onClose: () => {
            this.mostRecentPfostenart = null;
            APP.dirty();
          },
        });
        unveraendertePfosten.forEach((p) =>
          addWarning(
            getOBBWorld(p),
            (p.meta as MPfosten).Pfostenart?.[0].Key,
            [p],
            WARNUNG_DIALOG_KEYS.PFOSTENART_UNVERAENDERLICH
          )
        );
      }

      if (this.mostRecentPfostenart.Key == "Steckpfosten") {
        let warnings = false;
        const newSet = new Map(this.getEmpties().map((e) => [e.id, e]));
        [...newSet.entries()].forEach(([id, empty]) => {
          if (!lastIdEmptyBreiteMap.has(id) || lastIdEmptyBreiteMap.get(id) !== empty.breite) {
            addWarning(
              getOBBWorld(empty),
              I18N("Zusätzlicher Leerraum nach Wechsel auf Steckpfosten!"),
              [empty],
              WARNUNG_DIALOG_KEYS.STECKPFOSTEN_EXTRA_LUECKE
            );
            warnings = true;
          }
        });
        if (warnings) {
          Dialogs.showToast(
            I18N(
              "Neue oder größere Leerräume sind durch die geringere Pfostenbreite des Steckpfosten entstanden!"
            ),
            {
              onClose: () => {
                this.mostRecentPfostenart = null;
                APP.dirty();
              },
            }
          );
        }
      }
    }

    if (this.mostRecentBodenbefestigung && (!APP.messages?.state.hidden || isTest)) {
      const key = this.mostRecentBodenbefestigung?.Key;
      const unveraendertePfosten = this.getSelectedOrAllPfosten().filter(
        (p) =>
          !p.bodenbefestigungAuswahlwertIndividualisiert &&
          (p.meta as MPfosten)?.Bodenbefestigung &&
          !(p.isAufgeschraubt
            ? ["Aufgeschraubt auf festem Boden", "Aufgeschraubt mit Anker_Klemmpfosten"].includes(
                key
              )
            : key === "Einbetoniert im Boden")
      );
      if (unveraendertePfosten.length > 0) {
        Dialogs.showToast(I18N("Die Bodenbefestigung der markierten Pfosten ist unveränderlich!"), {
          onClose: () => {
            this.mostRecentBodenbefestigung = null;
            APP.dirty();
          },
        });
        unveraendertePfosten.forEach((p) =>
          addWarning(
            getOBBWorld(p),
            (p.meta as MPfosten).Bodenbefestigung?.[0].Key,
            [p],
            WARNUNG_DIALOG_KEYS.BODENBEFESTIGUNG_UNVERAENDERLICH
          )
        );
      }
    }

    if (this.maybeShowUmmantelungWarnung && (!APP.messages?.state.hidden || isTest)) {
      const pfostenOhneUmmantellung = this.getSelectedOrAllPfosten().filter(
        (p) =>
          p.ummantelungAuswahlwert.Key !== "Ummantelung_mit" ||
          Commons.isEmpty((p.meta as MPfosten)?.Ummantelung)
      );
      if (pfostenOhneUmmantellung.length > 0) {
        Dialogs.showToast(I18N("Für die markierten Pfosten ist keine Ummantelung verfügbar!"), {
          onClose: () => {
            this.maybeShowUmmantelungWarnung = null;
            APP.dirty();
          },
        });
        pfostenOhneUmmantellung.forEach((p) =>
          addWarning(
            getOBBWorld(p),
            I18N("Ohne Ummantelung"),
            [p],
            WARNUNG_DIALOG_KEYS.UMMANTELUNG_NICHT_VERFUEGBAR
          )
        );
      }
    }

    // prüfe, ob alle Parts (also idR. Pfosten an Element) mit dem korrekten Abstand aneinanderstehen
    this.segmente.forEach((s: Segment) => {
      const parts = s.getPartsAndPfosten();
      let pre = null;
      for (const part of parts) {
        if (pre != null && !pre.isEckadapter && !part.isEckadapter) {
          const { a, b, abstand, istLücke } = getLückeZwischen(s, pre, part);
          if (istLücke) {
            const box = pre.getBox().union(part.getBox());
            box.min.x = Math.min(a, b);
            box.max.x = Math.max(a, b);
            const obb = box3AndMatrixToOBB(box, s.matrixWorld);
            addWarning(
              obb,
              I18N("Lücke von %s", formatLength(abstand, 3)),
              [pre, part],
              WARNUNG_DIALOG_KEYS.LUECKE_ZWISCHEN_TEILEN
            );
          }
        }
        pre = part;
      }
    });

    // Warnung anzeigen, wenn ein Leerraum zwischen Mauer und Anschlagprofil entsteht
    this.getElemente()
      .filter((e: ZElement) => e.isTor && e.anMauer)
      .forEach((tor) => {
        const pfostenAnMauer = tor.getPfosten().find((p) => p.anMauer);
        const { nachbarLinks, nachbarRechts } = pfostenAnMauer;
        const nachbarLeerraum = [nachbarLinks, nachbarRechts].find(
          (nachbar) => (nachbar as Empty)?.isEmpty
        ) as Empty;

        if (nachbarLeerraum?.breite < pfostenbreiteCirca) {
          const abstand = nachbarLeerraum?.breite;
          const obb = nachbarLeerraum.getOBBWorld();
          addWarning(
            obb,
            I18N("Lücke von %s", formatLength(abstand, 3)),
            [nachbarLeerraum],
            WARNUNG_DIALOG_KEYS.LUECKE_MAUER_ANSCHLAGPROFIL
          );
        }
      });

    for (const { box, warnung, jacos } of iterateLichtleistenWarnungen(this, getOBBWorld)) {
      addWarning(box as OBB, warnung, jacos, WARNUNG_DIALOG_KEYS.LICHTLEISTE_WARNUNG);
    }

    this.getEckpfosten()
      .filter((p) => !p.matchingRotation)
      .forEach((p) => {
        addWarning(
          getOBBWorld(p),
          I18N("Für diesen Winkel passt der Pfosten nicht"),
          [p],
          WARNUNG_DIALOG_KEYS.ECKPFOSTEN_WINKEL_UNPASSEND
        );
      });

    // prüfe für alle Tor-Eckpfosten, ob der Winkel zum Tor der flachen Seite entspricht
    this.getEckpfosten()
      .filter((p) => p.isTorpfosten && p.isPfostenAnEcke && p.matchingRotation != null)
      .forEach((torPfosten) => {
        torPfosten.elemente
          .filter(
            (tor) =>
              tor.isTor &&
              !sindWinkelVielfache(
                tor.segment.angle,
                torPfosten.matchingRotation.angle,
                (90 * Math.PI) / 180,
                (0.1 * Math.PI) / 180
              )
          )
          .forEach((tor) => {
            addWarning(
              getOBBWorld(torPfosten),
              I18N("Torpfosten müssen mit der flachen Seite zum Tor stehen"),
              [tor, torPfosten],
              WARNUNG_DIALOG_KEYS.TORPFOSTEN_FLACHE_SEITE
            );
          });
      });

    const addPairwarning = (elements: (ZElement | Pfosten)[], warning: string) => {
      const initialValue = getOBBWorld(elements[0]);
      const box = elements.reduce((a, b) => getOBBWorld(b).union(a), initialValue);
      addWarning(box, warning, elements, WARNUNG_DIALOG_KEYS.INKOMPATIBLE_NACHBARN);
    };
    this.maybeShowInvalidPairs(addPairwarning);

    for (const tor of this.getTore()) {
      const info = tor.torMaxBreiteInfo;
      if (info == null) continue;
      const message = I18N(info.hinweisI18NKey, info.breite);
      const alteBreite = torBreiteMap.get(tor);
      if (alteBreite != null && alteBreite > info.breite) {
        this.elementeMitBreiteWarnung.add(tor);
        Dialogs.showToast(message, {
          type: "warning",
          onClose: () => {
            this.elementeMitBreiteWarnung.delete(tor);
            APP.dirty();
          },
        });
      }
      if (
        this.elementeMitBreiteWarnung.includes(tor) &&
        !this.selectedObjects.includes(tor) &&
        (!APP.messages?.state.hidden || isTest)
      ) {
        // wenn das Tor selektiert ist, wird bereits  ein weniger dominanter Hinweis
        // in Element3d.showHeightAndWidthLabel angezeigt
        addWarning(getOBBWorld(tor), message, [tor], WARNUNG_DIALOG_KEYS.TOR_MAX_BREITE);
      }
    }

    // Profilpositions-Warnungen: Elemente markieren, bei denen die globale Profilposition
    // außerhalb des gültigen Bereichs liegt (Toast wird in DekorOptionen.tsx ausgelöst)
    for (const element of this.elementeMitProfilpositionsWarnung) {
      if (element.showProfil) {
        addWarning(
          getOBBWorld(element),
          I18N("Die gewählte Profilposition wird auf den nächsten gültigen Wert angepasst."),
          [element],
          WARNUNG_DIALOG_KEYS.PROFILPOSITION_AUSSERHALB_BEREICH
        );
      }
    }

    const normalizeAngle = (angle: number) => {
      const twoPi = Math.PI * 2;
      let a = angle % twoPi;
      if (a < 0) a += twoPi;
      return a;
    };
    const angleInRange = (angle: number, start: number, end: number) => {
      const a = normalizeAngle(angle);
      const s = normalizeAngle(start);
      const e = normalizeAngle(end);
      return s <= e ? a >= s && a <= e : a >= s || a <= e;
    };
    const getSweep = (start: number, end: number) => {
      let sweep = normalizeAngle(end) - normalizeAngle(start);
      if (sweep < 0) sweep += Math.PI * 2;
      return sweep;
    };
    const getObbCorners = (obb: OBB) => {
      const axisX = v3(1, 0, 0).applyMatrix3(obb.rotation).normalize();
      const axisY = v3(0, 1, 0).applyMatrix3(obb.rotation).normalize();
      const axisZ = v3(0, 0, 1).applyMatrix3(obb.rotation).normalize();
      const hx = axisX.multiplyScalar(obb.halfSize.x);
      const hy = axisY.multiplyScalar(obb.halfSize.y);
      const hz = axisZ.multiplyScalar(obb.halfSize.z);

      const corners: Vector3[] = [];
      [-1, 1].forEach((sx) => {
        [-1, 1].forEach((sy) => {
          [-1, 1].forEach((sz) => {
            corners.push(
              obb.center
                .clone()
                .add(hx.clone().multiplyScalar(sx))
                .add(hy.clone().multiplyScalar(sy))
                .add(hz.clone().multiplyScalar(sz))
            );
          });
        });
      });
      return corners;
    };
    const pointInSektorXZ = (point: Vector3, sektor: FlügelÖffnungsbereichZylinderSektor) => {
      const dx = point.x - sektor.pivot.x;
      const dz = point.z - sektor.pivot.z;
      const radius = Math.hypot(dx, dz);
      if (radius < sektor.radiusInner - 0.002 || radius > sektor.radiusOuter + 0.002) {
        return false;
      }
      return angleInRange(Math.atan2(dz, dx), sektor.startAngle, sektor.endAngle);
    };
    const getObbSamplePoints = (obb: OBB) => {
      const axisX = v3(1, 0, 0).applyMatrix3(obb.rotation).normalize();
      const axisY = v3(0, 1, 0).applyMatrix3(obb.rotation).normalize();
      const axisZ = v3(0, 0, 1).applyMatrix3(obb.rotation).normalize();
      const tx = [-1, -0.5, 0, 0.5, 1];
      const tz = [-1, -0.5, 0, 0.5, 1];
      const ty = [0];
      const points: Vector3[] = [];
      tx.forEach((x) => {
        tz.forEach((z) => {
          ty.forEach((y) => {
            points.push(
              obb.center
                .clone()
                .add(axisX.clone().multiplyScalar(obb.halfSize.x * x))
                .add(axisY.clone().multiplyScalar(obb.halfSize.y * y))
                .add(axisZ.clone().multiplyScalar(obb.halfSize.z * z))
            );
          });
        });
      });
      return points;
    };
    const getSektorSamplePoints = (sektor: FlügelÖffnungsbereichZylinderSektor) => {
      const sweep = getSweep(sektor.startAngle, sektor.endAngle);
      const angleSteps = Math.max(8, Math.ceil((sweep / (Math.PI * 2)) * 32));
      const angles = Array.from({ length: angleSteps + 1 }, (_, i) =>
        normalizeAngle(sektor.startAngle + (sweep * i) / angleSteps)
      );
      const radii = [
        sektor.radiusInner,
        sektor.radiusInner * 0.75 + sektor.radiusOuter * 0.25,
        (sektor.radiusInner + sektor.radiusOuter) * 0.5,
        sektor.radiusInner * 0.25 + sektor.radiusOuter * 0.75,
        sektor.radiusOuter,
      ];
      const y = (sektor.yMin + sektor.yMax) * 0.5;
      return angles.flatMap((a) =>
        radii.map((r) => v3(sektor.pivot.x + r * Math.cos(a), y, sektor.pivot.z + r * Math.sin(a)))
      );
    };
    const sektorIntersectsObb = (sektor: FlügelÖffnungsbereichZylinderSektor, obb: OBB) => {
      const corners = getObbCorners(obb);
      const yValues = corners.map((c) => c.y);
      const yMin = Math.min(...yValues);
      const yMax = Math.max(...yValues);
      if (yMax < sektor.yMin - 0.002 || yMin > sektor.yMax + 0.002) {
        return false;
      }

      if (corners.some((c) => pointInSektorXZ(c, sektor))) {
        return true;
      }

      const probePoints = [
        obb.center,
        ...corners,
        ...corners.slice(0, 4).map((c, i) =>
          c
            .clone()
            .add(corners[i + 4])
            .multiplyScalar(0.5)
        ),
      ];
      if (probePoints.some((p) => pointInSektorXZ(p, sektor))) {
        return true;
      }

      const denseObbPoints = getObbSamplePoints(obb);
      if (denseObbPoints.some((p) => pointInSektorXZ(p, sektor))) {
        return true;
      }

      const midY = Maths.clamp((sektor.yMin + sektor.yMax) * 0.5, yMin, yMax);
      const midAngle = normalizeAngle(
        sektor.startAngle + getSweep(sektor.startAngle, sektor.endAngle) * 0.5
      );
      const sektorProbe = [
        [sektor.radiusInner, sektor.startAngle],
        [sektor.radiusOuter, sektor.startAngle],
        [sektor.radiusInner, sektor.endAngle],
        [sektor.radiusOuter, sektor.endAngle],
        [(sektor.radiusInner + sektor.radiusOuter) * 0.5, midAngle],
      ].map(([r, a]) =>
        v3(sektor.pivot.x + r * Math.cos(a), midY, sektor.pivot.z + r * Math.sin(a))
      );

      if (sektorProbe.some((p) => obb.containsPoint(p))) {
        return true;
      }

      return getSektorSamplePoints(sektor).some((p) => obb.containsPoint(p));
    };
    const toWarnungSektor = (
      sektor: FlügelÖffnungsbereichZylinderSektor
    ): WarnungZylinderSektor => ({
      type: "zylindersektor",
      pivot: sektor.pivot.clone(),
      radiusInner: sektor.radiusInner,
      radiusOuter: sektor.radiusOuter,
      yMin: sektor.yMin,
      yMax: sektor.yMax,
      startAngle: sektor.startAngle,
      endAngle: sektor.endAngle,
    });

    const toreMitFlügel = this.getTore().filter((tor) => !tor.isSchiebetor);
    const torSektorenMap = new Map<ZElement, FlügelÖffnungsbereichZylinderSektor[]>(
      toreMitFlügel.map((tor) => [tor, tor.getFlügelÖffnungsbereichWarnSektoren()])
    );

    const schiebetore = this.getTore().filter((t) => t.isSchiebetor);
    if (schiebetore.length > 0) {
      const obbs = [...this.getElemente(), ...this.aufbauten.filter((a) => a?.isMauer())].map(
        (p) => [p, getOBBWorld(p)] as [Jaco, OBB]
      );
      for (const tor of schiebetore) {
        const box3 = tor.getSchiebetorOffenBox();
        if (box3 == null) {
          continue;
        }
        const obb = Maths3.box3AndMatrixToOBB(box3, tor.segment.matrixWorld);
        const teilCollisions = obbs.filter(([p, pobb]) => p !== tor && obb.intersectsOBB(pobb));
        const flügelSektorCollisions = toreMitFlügel.flatMap((flügelTor) =>
          (torSektorenMap.get(flügelTor) ?? [])
            .filter((sektor) => sektorIntersectsObb(sektor, obb))
            .map((sektor) => ({ flügelTor, sektor }))
        );

        if (teilCollisions.length > 0 || flügelSektorCollisions.length > 0) {
          addWarning(
            obb,
            I18N("Das Schiebetor kollidiert im offenen Zustand mit anderen Teilen"),
            [tor],
            WARNUNG_DIALOG_KEYS.SCHIEBETOR_KOLLIDIERT_MIT_TEIL
          );
          teilCollisions.forEach(([part, pobb]) => {
            addWarning(
              pobb,
              I18N("Dieses Teil kollidiert mit dem Schiebetor, wenn es offen ist"),
              [part],
              WARNUNG_DIALOG_KEYS.TEIL_KOLLIDIERT_MIT_SCHIEBETOR
            );
          });
          flügelSektorCollisions.forEach(({ flügelTor, sektor }) => {
            addWarning(
              toWarnungSektor(sektor),
              I18N("warnung::Torflügel kollidiert im Öffnungsbereich mit anderen Teilen"),
              [flügelTor, tor],
              WARNUNG_DIALOG_KEYS.TORFLUEGEL_KOLLISION
            );
          });
        }
      }
    }

    if (toreMitFlügel.length > 0) {
      const ankerTeile = this.getPfosten()
        .map((pfosten) => pfosten.anker)
        .filter((anker) => anker != null);
      const szeneTeile = [...this.getPartsAndPfosten(), ...ankerTeile, ...this.aufbauten].filter(
        (teil) => !teil.isEmpty
      );
      for (const tor of toreMitFlügel) {
        const ignorierteTeile = new Set<any>([
          tor,
          tor.pfostenLinks,
          tor.pfostenRechts,
          tor.umprofilLinks,
          tor.umprofilRechts,
        ]);

        const flügelSektorenFürWarnung = torSektorenMap.get(tor) ?? [];
        const kollidierendeSektoren: FlügelÖffnungsbereichZylinderSektor[] = [];
        const kollidierendeTeile = new Set<Jaco>();
        const kollidierendeTore = new Set<ZElement>();

        for (const flügelSektor of flügelSektorenFürWarnung) {
          const teilCollisions = szeneTeile.filter(
            (teil) =>
              !ignorierteTeile.has(teil) && sektorIntersectsObb(flügelSektor, getOBBWorld(teil))
          );
          if (teilCollisions.length > 0) {
            kollidierendeSektoren.push(flügelSektor);
            teilCollisions.forEach((teil) => {
              if ((teil as ZElement).isTor) {
                kollidierendeTore.add(teil as ZElement);
              } else {
                kollidierendeTeile.add(teil);
              }
            });
          }
        }

        if (kollidierendeSektoren.length > 0) {
          kollidierendeSektoren.forEach((warnSektor) => {
            addWarning(
              toWarnungSektor(warnSektor),
              I18N("warnung::Torflügel kollidiert im Öffnungsbereich mit anderen Teilen"),
              [tor],
              WARNUNG_DIALOG_KEYS.TORFLUEGEL_KOLLISION
            );
          });
          kollidierendeTeile.forEach((teil) => {
            addWarning(
              getOBBWorld(teil),
              I18N("warnung::Dieses Teil kollidiert mit dem Öffnungsbereich eines Torflügels"),
              [teil, tor],
              WARNUNG_DIALOG_KEYS.TORFLUEGEL_KOLLISION_TEIL
            );
          });
          kollidierendeTore.forEach((anderesTor) => {
            addWarning(
              getOBBWorld(anderesTor),
              I18N("warnung::Dieses Teil kollidiert mit dem Öffnungsbereich eines Torflügels"),
              [anderesTor, tor],
              WARNUNG_DIALOG_KEYS.TORFLUEGEL_KOLLISION_TEIL
            );
          });
        }
      }
    }

    warnungenPool.cleanup();
    this.warnungen.forEach((w) => w.update3d());
  }

  updateAufbauten() {
    this.aufbauten.forEach((aufbau) => aufbau.update3d());
  }

  updateTorAuswahlwerte() {
    const torAuswahlwerte = [
      "füllungAuswahlwert",
      "rahmenAuswahlwert",
      "profilAuswahlwert",
      "profilPosition",
      "showProfil",
      "profilleisteAuswahlwert",
      "öffnungAuswahlwert",
      "füllungsseiteAuswahlwert",
      "drückerAuswahlwert",
      "profilzylinderAuswahlwert",
      "toröffnerAuswahlwert",
      "torschließerAuswahlwert",
    ];
    const pfostenAuswahlwerte = [
      "pfostenartAuswahlwert",
      "pfostenartAuswahlwertIndividualisiert",
      "pfostenfarbeAuswahlwert",
      "pfostenfarbeAuswahlwertIndividualisiert",
      "bodenbefestigungAuswahlwert",
      "bodenbefestigungAuswahlwertIndividualisiert",
      "verbundankerAuswahlwert",
      "ummantelungAuswahlwert",
      "pfostenkappeAuswahlwert",
    ];

    const nullWerteSindGültig = (auswahlwertKey: string) => !auswahlwertKey.endsWith("Auswahlwert");

    const getDefaultAuswahlwert = (key: string) =>
      this[key + "Default"] ??
      (nullWerteSindGültig(key)
        ? null
        : APP.richMetadata.getAuswahlWertVoreinstellungForKey(
            _.upperFirst(key.substringBefore("Auswahlwert"))
          ));

    // stellt sicher, dass alle objects dieselben Auswahlwerte haben,
    // und priorisiert bei Abweichung den Auswahlwert, der dem
    // selektierten Objekt und ansonsten dem nicht-Default entspricht.
    const ensureSameAuswahlwerte = (objects: any[], auswahlwerteKeys: string[]) => {
      auswahlwerteKeys.forEach((auswahlwertKey) => {
        let mapAuswahlwerte = (list) => {
          list = list.map((p) => p[auswahlwertKey]);
          if (!nullWerteSindGültig(auswahlwertKey)) {
            // null - Werte können vorkommen und müssen für Auswahlwerte rausgefiltert werden. Sie entstehen z.B.
            // beim elementhalterAuswahlwert bei Gehflügel-Torpfosten, die gar keine Elementhalter haben
            list = list.filter((w) => w != null);
          }
          return list;
        };
        const werteSet = new Set(mapAuswahlwerte(objects));
        if (werteSet.length > 1) {
          let prioWerte = new Set(mapAuswahlwerte(objects.filter((p) => p.selected)));
          prioWerte = prioWerte.length > 0 ? prioWerte : werteSet;
          const defaultWert = getDefaultAuswahlwert(auswahlwertKey);
          const sollWert = prioWerte.toArray().find((w) => w != defaultWert) ?? prioWerte.first();
          objects.forEach((o) => {
            if (o[auswahlwertKey] != sollWert) {
              if (auswahlwertKey == "füllungAuswahlwert") {
                o.change({ füllungAuswahlwert: sollWert });
              } else {
                o[auswahlwertKey] = sollWert;
              }
              APP.dirty();
            }
          });
        }
      });
    };

    // betrachte den Zaun als Graphen von Elementen, die über gemeinsame Pfosten verbunden sind,
    // und finde alle zusammenhängenden Graphen von Toren (damit sind also
    // Einzel-, Doppel-, Dreifachtore und über Eck stehende Tore erfasst).
    const tore = this.getTore();
    const torAdjazenz = Commons.cache((tor: ZElement) =>
      new Set(
        tor
          .getPfosten()
          .filter((pfosten) => !pfosten.elemente.some((e) => e.isSchiebetor))
          .flatMap((pfosten) => pfosten.elemente.filter((e) => e.isTor))
      ).filter((e) => e !== tor)
    );
    const torSubgraphs = Commons.findConnectedSubgraphs(tore, (tor: ZElement, hops: number) =>
      torAdjazenz(tor)
    );
    const zusammenhängendeTore = filterUniqueSetsBy<ZElement>(
      torSubgraphs.map((g) => new Set(g)),
      (e) => e.id
    ).map((s) => s.toArray());
    zusammenhängendeTore.forEach((tore: ZElement[]) => {
      const torpfosten = new Set(
        tore.flatMap((tor) => tor.getPfosten().filter((p) => p.isTorpfosten))
      ).toArray();
      ensureSameAuswahlwerte(tore, torAuswahlwerte);
      ensureSameAuswahlwerte(torpfosten, pfostenAuswahlwerte);
    });
  }

  createJaco3d() {
    const x = super.createJaco3d();
    if (APP.debugMode) {
      x.add(new OcAxisHelper());
    }
    return x;
  }

  updateLichtleisten() {
    const updateTrafos = (trees: Tree[]) => {
      const trafos = this.aufbauten.filter((a) => a.isTrafo());
      trees.forEach((tree, index) => {
        const start = startPositionOfTree(tree);
        if (!start) {
          console.error("tree is empty", tree);
          return;
        }
        const position = Maths3.v2To3xz(start);
        if (index < trafos.length) {
          // Trafo updaten
          trafos[index].position.copy(position);
        } else {
          // Trafo neu erzeugen
          const aufbauMeta = APP.richMetadata.findAufbauten("Trafo");
          const newTrafo = new Aufbau(this, {
            Key: Commons.createUniqueIdString(),
            aufbauMeta,
            position,
            size: aufbauMeta.Size3d,
          });
          this.aufbauten.push(newTrafo);
          trafos.push(newTrafo);
        }
      });
      if (trees.length < trafos.length) {
        // lösche überzählige Trafos
        let trafoAnzahl = 0;
        const trafosNeeded = trees.length;
        this.aufbauten = this.aufbauten.filter((a) => !a.isTrafo() || trafoAnzahl++ < trafosNeeded);
      }
    };
    const updateKabel = (trees: Tree[]) => {
      const trafos = this.aufbauten.filter((a) => a.isTrafo());
      const kabelPool = this.lazyPool(this.kabel, () => new Stromkabel(this));
      let y = -0.04;
      const dy = -0.03;
      trees.forEach((tree, treeIndex) => {
        y += dy;
        const trafo = trafos[treeIndex];
        trafo.color = lowDiscrepancyColorSequence[treeIndex % lowDiscrepancyColorSequence.length];
        trafo.tree = tree;
        trafo.treeIndex = treeIndex;
        const { liste, y: y2 } = verlegeKabelEntlangDesBaumes(tree, y, dy);
        liste.forEach(
          ({ länge, pfad, lichtAnschlüsse, startAnschluss, endAnschluss, schlaufen }, index) => {
            const kabel = kabelPool.next();
            kabel.init(
              trafo,
              länge,
              pfad,
              lichtAnschlüsse,
              startAnschluss,
              endAnschluss,
              index,
              schlaufen
            );
            kabel.update3d();
          }
        );
        y = y2;
      });

      kabelPool.cleanup();
    };

    if (this.segmente.some((s: Segment) => s.ecken.length == 0 || s.ecken.some((e) => e == null))) {
      return;
    }
    // console.time("getKabelbäumeFromArrangement");
    const trees = (this.trafoTrees = getKabelbäumeFromArrangement(this));
    if (trees.length == 0 && APP.nightMode) {
      APP.toggleDaytime();
    }
    // console.timeEnd("getKabelbäumeFromArrangement");
    updateTrafos(trees);
    updateKabel(trees);
    this.lichtleistenSplitter = this.kabel.filter(
      (kabel) => kabel.startAnschluss == "Bus" || kabel.endAnschluss == "Bus"
    ).length;

    this.hasOnlyRhombusLichtleisten = this.getElemente()
      .filter((e) => e.anzahlLichtleisten > 0)
      .every((e) => e.isRhombusOderRhombusHolz);
  }

  getBox(): Box3 {
    return this.grundriss.boundingBox;
  }

  fillIndividuellSegmentsWithElements() {
    return this.forNurMasseUpdaten(() => {
      this.update3d();
      const getDefaultElementCached = Commons.cache(() => this.createDefaultElementWithout3D());
      const segmenteElemente: { segment: Segment; elementeAdded: ZElement[] }[] = [];
      this.segmente
        .filter((segment) => segment.verteilungsstrategieAuswahlwert?.Key === "Individuell")
        .forEach((segment) => {
          let elementeAdded = [];
          segment.getEmpties().forEach((empty) => {
            elementeAdded = elementeAdded.concat(
              empty.fillWithElements(getDefaultElementCached(), { allowMassElement: true })
            );
          });
          segmenteElemente.push({ segment, elementeAdded });
        });

      this.update3d();

      // Es kann sein, dass sich durch das segmentübergreifende Auffüllen Eckpfosten nachträglich
      // in ihrer Breite verändern - Beispiel ist
      // TestEckpfosten.testIndividuelleVerteilungElementeOkBeiEcksituation135Grad
      // Um damit umzugehen, wird hier das Delta nachträglich auf die Elementbreiten hinzuaddiert.
      for (const { segment, elementeAdded } of segmenteElemente) {
        const [elementLinks, elementRechts] = segment.ecken.map((ecke) =>
          ecke?.pfosten?.elemente.find((e) => elementeAdded.includes(e))
        );
        const getLuecke = (partLinks, partRechts) => {
          if (partLinks == null || partRechts == null) {
            return 0;
          }
          const a = segment.getX(partLinks, 1) + partLinks.gapRechts;
          const b = segment.getX(partRechts, 0) - partRechts.gapLinks;
          return b - a;
        };
        const lueckeLinks = elementLinks && getLuecke(elementLinks.nachbarLinks, elementLinks);
        const lueckeRechts = elementRechts && getLuecke(elementRechts, elementRechts.nachbarRechts);
        const epsilon = 0.005;
        if (Math.abs(lueckeLinks) > epsilon) {
          elementLinks.breite += lueckeLinks;
        }
        if (Math.abs(lueckeRechts) > epsilon) {
          elementRechts.breite += lueckeRechts;
        }
      }

      this.update3d();

      return segmenteElemente.flatMap(({ elementeAdded }) => elementeAdded);
    });
  }

  forNurMasseUpdaten(callback: Function) {
    const before = this.nurMasseUpdaten;
    try {
      this.nurMasseUpdaten = true;
      return callback();
    } finally {
      this.nurMasseUpdaten = before;
    }
  }

  createDefaultElement(options: any = {}) {
    const element = this.ghostPool.withPool(() =>
      this.createElement(this.getElementDefaultOptions(options))
    );
    return element;
  }

  createDefaultElementWithout3D(options: any = {}) {
    const element = new ZElement(this);
    element.change(this.getElementDefaultOptions(options));
    element.updateMetaAndSize();
    return element;
  }

  createElement(options: any): ZElement {
    const element = new ZElement(this);
    element.change(options);
    element.update3d();
    return element;
  }

  private getElementDefaultOptions(options: any = {}) {
    return {
      massAuswahlwert: this.massAuswahlwertDefault,
      füllungAuswahlwert: this.füllungAuswahlwertDefault,
      size: this.sizeDefault,
      ...options,
    };
  }

  /**
   * Erzeugt ein Element für Tests oder für die ChatBot-API. Dabei kann auch nur ein Teil der
   * Daten gesetzt sein.
   */
  createElementFromJson(options: any = {}) {
    const element: ZElement = this.ghostPool.withPool(() => {
      // da die Size / Mass / Füllung sich beeinflussen und die Size Schwellwerte hat,
      // werden diese gesondert behandelt und schon in der createElement verwendet
      let o: any = {};
      if (options.form) {
        o.form = APP.richMetadata.findForm(options.form);
      }
      if (options.massAuswahlwert) {
        o.massAuswahlwert = APP.richMetadata.findAuswahlwert(options.massAuswahlwert);
      }
      if (options.füllungAuswahlwert) {
        o.füllungAuswahlwert = APP.richMetadata.findAuswahlwert(options.füllungAuswahlwert);
      }
      if (options.nimmStandardSize) {
        o.maximalBreite = 10;
        o.size = getStandardSize(o);
      } else {
        o.size = v2(options.breite ?? this.sizeDefault.x, options.höhe ?? this.sizeDefault.y);
      }
      const element = this.createElement(o);
      if (options.nimmStandardSize) {
        options.breite = element.breite;
        options.höhe = element.höhe;
      }
      // für alle weiteren "einfachen" Parameter reicht das fromJSON
      element.fromJSON({ ...element.toJSON(), ...options });
      element.updateInner();
      return element;
    });
    return element;
  }

  getElemente(): ZElement[] {
    return this.segmente.flatMap((segment) => segment.getElemente());
  }

  getTore(): ZElement[] {
    return this.segmente.flatMap((segment) => segment.getTore());
  }

  getParts(): any[] {
    return this.segmente.flatMap((segment) => segment.getParts());
  }

  getPartsAndPfosten(): any[] {
    const partsAndPfosten = this.segmente
      .flatMap((segment) => segment.getPartsAndPfosten())
      .filter((p) => !p.isPfostenAnEcke);
    return this.getEckpfosten().concat(partsAndPfosten);
  }

  getPfosten(): Pfosten[] {
    const pfosten = this.segmente
      .flatMap((segment) => segment.getPfosten())
      .filter((p) => !p.isPfostenAnEcke);
    return this.getEckpfosten().concat(pfosten);
  }

  getTorpfosten(): Pfosten[] {
    return this.getPfosten().filter((p) => p.isTorpfosten);
  }

  getEckpfosten(): Pfosten[] {
    return this.ecken.map((e) => e.pfosten).filter((p) => p != null);
  }

  getFundamente(): Fundament[] {
    const pfostenFundamente = this.getPfosten()
      .map((p) => p.fundament)
      .filter((f) => f != null);
    const schiebetorFundamente = this.getElemente()
      .filter((e) => e.isSchiebetor)
      .flatMap((e) =>
        ["Schiebetor_Fundament1", "Schiebetor_Fundament2", "Schiebetor_Fundament3"]
          .map((key) => e.schiebetorFixPunkt[key] as Fundament)
          .filter((f) => f != null)
      );
    return [...pfostenFundamente, ...schiebetorFundamente];
  }

  getEmpties(): Empty[] {
    return this.segmente.flatMap((segment) => segment.empties);
  }

  fadeObjects(fadeIn: boolean) {
    const fn = fadeIn ? (t) => t : (t) => 1 - t;
    const targetOpacity = 0.2;
    APP.tween(
      (t) =>
        this.fadeOutObjects.forEach(
          (p) => (p.opacity = fn(t) * (1 - targetOpacity) + targetOpacity)
        ),
      600
    );
  }

  async setSelectedObjects(
    partOrArrayOfParts: any = [],
    updateCamera = JSON.parse(localStorage["isAutoCameraOn"] ?? "true")
  ) {
    let parts = Array.isArray(partOrArrayOfParts) ? partOrArrayOfParts : [partOrArrayOfParts];
    parts = _.uniq(parts.filter((p) => p != null));
    const selectedObjectChanged = !Commons.arraysEqual(this.selectedObjects, parts);

    if (!selectedObjectChanged) {
      return;
    }

    const previousSelectionContainsPfosten = this.selectedObjects?.some((e) => e.isPfosten);

    this.fadeOutObjects = APP.getSceneBackgroundObjects().filter((p) =>
      ["ground", "groundRaster"].includes(p.name)
    );
    if (parts.length > 0 && parts[0].isPfosten && !previousSelectionContainsPfosten) {
      this.fadeObjects(false);
    } else if (!parts.some((e) => e.isPfosten) && previousSelectionContainsPfosten) {
      this.fadeObjects(true);
    }

    if (this.selectedObjects.length > 1) {
      this.selectedObjects.forEach((selectedZaunelementOrPfosten) => {
        if (selectedZaunelementOrPfosten.jaco3d) {
          selectedZaunelementOrPfosten.jaco3d.selected = false;
        }
      });
    } else {
      if (this.selectedObjects[0]?.jaco3d) {
        this.selectedObjects[0].jaco3d.selected = false;
      }
    }

    this.selectedObjects = parts;

    this.selectedObjects.filter((e) => e?.jaco3d).forEach((e) => (e.jaco3d.selected = true));

    const finish = () => {
      APP.trigger("selectZaunelementOrPfosten");
      this.selectedObjects[0]?.isElement && APP.trigger("selectZaunelement");
      APP.dirty();
    };
    if (selectedObjectChanged) {
      APP.trigger("selectionChangeStart");
      APP.logUserAction(
        { action: "selectedObjects", selectedObjects: parts },
        { stateChange: false }
      );
    }
    if (updateCamera && selectedObjectChanged) {
      await APP.zoomCameraToPart(parts.length == 1 ? parts[0] : null);
      finish();
    } else {
      finish();
    }

    this.updateFüllungAuswahlwert();
  }

  clone() {
    const clone = new Arrangement();
    clone.fromJSON(this.toJSON());
    const cloneElements = clone.getElemente();
    const thisElements = this.getElemente();
    if (this.selectedObjects[0]?.isElement) {
      const index = thisElements.indexOf(this.selectedObjects[0]);
      clone.selectedObjects[0] = cloneElements[index];
    }
    clone.selectedObjects =
      this.selectedObjects
        ?.map((e) => cloneElements[thisElements.indexOf(e)])
        .filter((e) => e != null) ?? [];
    clone.füllungAuswahlwertHistory = Array.from(this.füllungAuswahlwertHistory);
    clone.update3d();
    return clone;
  }

  get montageanleitungen(): {
    MontageanleitungPdf: string;
    ArtikelID: string;
    MontagePdfKuerzel: string;
  }[] {
    return _.uniqBy(
      this.bestellliste
        .filter(({ MontageanleitungPdf }) => !Commons.isEmpty(MontageanleitungPdf))
        .map(({ MontageanleitungPdf, ArtikelID, MontagePdfKuerzel }) => ({
          MontageanleitungPdf,
          ArtikelID,
          MontagePdfKuerzel,
        })),
      ({ MontageanleitungPdf }) => MontageanleitungPdf
    );
  }

  get inspirationsBilder(): string[] {
    const bilderUrls = this.getParts()
      .filter((p) => p.isElement)
      .map((e) => e?.getInspirationsBild()?.split("/"))
      .filter((url) => url != undefined);
    const uniqInspirationsbilder = _.uniqBy(bilderUrls, (b) => b[b.length - 1]);
    return uniqInspirationsbilder.map((b) => "/".concat(b[b.length - 2], "/", b[b.length - 1]));
  }

  toJSON(): any {
    let pfostenartAuswahlwert: string = this.pfostenartAuswahlwert?.Key;
    const pfostenarten: string[] = this.getPfosten()
      .map((p) => (p.meta as MPfosten).Pfostenart?.[0].Key)
      .filter((p) => p != undefined);
    if (!pfostenarten.includes(pfostenartAuswahlwert) && pfostenarten.length > 0) {
      const häufigstePfostenart = _.head(_(pfostenarten).countBy().entries().maxBy(_.last));
      pfostenartAuswahlwert = häufigstePfostenart;
    }

    const warnungenMitWichtigkeit = mergeWarnungenByText(this.warnungen).map(
      ({ text, wichtigkeit }) => ({
        text,
        wichtigkeit,
        color: getWarnungWichtigkeitColor(wichtigkeit).text,
      })
    );

    const json = {
      inspiration: this.inspiration?.Inspiration?.Key,
      zaunart: this.zaunart?.Key,
      serie: this.serie?.Key,
      grundriss: this.grundriss?.toJSON(),
      segmente: this.segmente.map((x) => x.toJSON()),
      ecken: this.ecken?.map((x) => x.toJSON()),
      aufbauten: this.aufbauten.map((x) => x.toJSON()),
      lichtleistenSplitter: this.lichtleistenSplitter,
      lichttrafoAuswahlwert: this.lichttrafoAuswahlwert?.Key,
      lichtleistenZubehör: Commons.cloneDeep(this.lichtleistenZubehörAnzahl),
      pfostenartAuswahlwert: pfostenartAuswahlwert,
      pfostenfarbeAuswahlwert: this.pfostenfarbeAuswahlwert_?.Key,
      bodenbefestigungAuswahlwert: this.bodenbefestigungAuswahlwert_?.Key,
      elementhalterAuswahlwert: this.elementhalterAuswahlwert_?.Key,
      verteilungsstrategieAuswahlwert: this.verteilungsstrategieAuswahlwert_?.Key,
      montageadapterAuswahlwert: this.getPfosten().find(
        (pfosten) =>
          isAufgeschraubt(pfosten.bodenbefestigungAuswahlwert) &&
          pfosten.montageadapterAuswahlwert?.Key === "Montageadapter_mit"
      )?.montageadapterAuswahlwert?.Key,
      verbundankerAuswahlwert: this.getPfosten().find(
        (pfosten) =>
          isAufgeschraubt(pfosten.bodenbefestigungAuswahlwert) &&
          pfosten.verbundankerAuswahlwert?.Key === "Verbundanker-Set_mit"
      )?.verbundankerAuswahlwert?.Key,
      ummantelungAuswahlwert: this.getPfosten().find(
        (pfosten) =>
          isKlemmpfosten(pfosten.pfostenartAuswahlwert) &&
          pfosten.ummantelungAuswahlwert?.Key === "Ummantelung_mit"
      )?.ummantelungAuswahlwert?.Key,
      bestellliste: this.bestellliste
        .filter((a) => !a.UserDefined)
        .map(({ ArtikelID, Anzahl, AnzahlEditiert, Mass, ElementIndizes }) => ({
          ArtikelID,
          Anzahl,
          AnzahlEditiert,
          Mass,
          ElementIndizes: ElementIndizes.map((index) =>
            this.maybeGetDreifachtorPartnerIndex(index, ArtikelID)
          ),
        })),
      customAnzahlen: Commons.cloneDeep(this.customAnzahlen),
      gesamtpreis: this.gesamtpreis,
      baugruppen: this.baugruppen.map((liste) =>
        liste.map(({ ArtikelID, Anzahl, MassOrBauseitsTag }) => ({
          ArtikelID,
          Anzahl,
          MassOrBauseitsTag,
        }))
      ),
      warnungen: warnungenMitWichtigkeit.map((warnung) => warnung.text),
      warnungenMitWichtigkeit,
      montageanleitungenArtikelIDs: this.montageanleitungen.map(
        (montageanleitung) => montageanleitung.ArtikelID
      ),
      inspirationsBilder: this.inspirationsBilder,
      pageName: APP.pageName,
      userDefinedArticles: this.userDefinedArticles.map((a) => {
        return { ...a };
      }),
      hinweistexte: getHinweistexteAuswahlwertKeys(),
      zauneditorVisited: this.zauneditorVisited,
    };
    return json;
  }

  fromJSON(json: any = {}) {
    const setAuswahlwert = (value: MAuswahlwert, setter: (MAuswahlwert) => void) => {
      const auswahlwert = APP.richMetadata.findEnsureAuswahlwert(value);
      if (auswahlwert != null) {
        setter(auswahlwert);
      }
    };
    this.zaunart = APP.richMetadata.findAuswahlwertOrDefault(json.zaunart, "Zaunart");
    // this.serie = APP.richMetadata.findEnsureAnyObjekt(json.serie);
    let jsonSegmente = json.segmente ?? [];
    if (json.grundriss) {
      this.grundriss.fromJSON(json.grundriss);
    } else if (json.form) {
      // Kompatibilität mit altem Format
      this.grundriss.setStandardForm(
        json.form.type,
        json.form.seitenLaengen,
        json.form.zaunSeitenFüllen,
        true
      );
      const jsonSegmentFormSeitenIndexMap = Commons.groupBy(
        jsonSegmente,
        (s: any, i) => s.formSeitenIndex ?? i
      );
      const form = json.form.type;
      const formOrders = {
        Rechteck: [3, 0, 2, 1],
        LForm: [1, 2, 3, 0, 4, 5],
        Strecke: [0],
      };
      jsonSegmente = formOrders[form].flatMap(
        (i) =>
          jsonSegmentFormSeitenIndexMap.get(i) ?? [
            {
              formSeitenIndex: i,
              partsAndPfosten: [],
            },
          ]
      );
    }
    this.inspiration = APP.richMetadata.findAnyObjekt(json.inspiration);
    this.segmente = jsonSegmente.map((x) => new Segment(this).fromJSON(x)) || [];
    this.ecken = this.grundriss.ecken.map((p, i) => {
      const ecke = new Ecke(this);
      ecke.position.copy(Maths3.v2To3xz(p.punkt));
      json.ecken?.[i] && ecke.fromJSON(json.ecken[i]);
      return ecke;
    });
    this.aufbauten =
      json.aufbauten?.map((x) => new Aufbau(this).fromJSON(x)).filter((x) => x != null) || [];

    if (!json.grundriss && json.form) {
      // Im alten JSON-Format ist die Zuordnung der Eck-Pfosten zu Ecken nicht gespeichert
      // Um diese zu rekonstruieren, müssen die Segmente anhand der Aufbauten geschnitten werden,
      // damit die Zuordnung der Segmente zu Ecken bekannt ist. Anschließend können die Grenzpfosten
      // der Segmente den Ecken zugeordnet werden.
      const lazyPoolEcken = this.lazyPool(this.ecken, () => new Ecke(this));
      const lazyPoolSegmente = this.lazyPool(this.segmente, () => new Segment(this));
      this.updateGrundriss();
      this.updateAufbauten();
      schneideEckenUndSegmente({
        ...this,
        verteilungsstrategieAuswahlwert_: APP.richMetadata.findAuswahlwert("Individuell"),
        partsAndPfosten: [],
        lazyPoolEcken,
        lazyPoolSegmente,
      });
      this.segmente.forEach((segment: Segment) => {
        [...segment.pfosten].forEach((pfosten) => {
          const epsilon = 0.4;
          const setEckpfosten = (ecke) => {
            pfosten.parent = this;
            ecke.pfosten = pfosten;
            pfosten.ecke = ecke;
            pfosten.position.copy(ecke.position);
            // segment.pfosten = segment.pfosten.filter((p) => p != pfosten);
          };
          if (Math.abs(pfosten.position.x) < epsilon) {
            setEckpfosten(segment.ecken[0]);
          } else if (Math.abs(segment.breite - pfosten.position.x) < epsilon) {
            setEckpfosten(segment.ecken[1]);
          }
        });
      });
    }

    this.lichtleistenSplitter = json.lichtleistenSplitter ?? 0;
    this.lichtleistenZubehörAnzahl = {
      ...this.getDefaultLichtleistenZubehörAnzahl(),
      ...json.lichtleistenZubehör,
    };
    setAuswahlwert(json?.lichttrafoAuswahlwert, (v) => (this.lichttrafoAuswahlwert = v));
    this.selectedObjects = [];
    this.mostRecentPfostenart = null;
    setAuswahlwert(json?.pfostenartAuswahlwert, (v) => (this.pfostenartAuswahlwert = v));
    setAuswahlwert(json?.pfostenfarbeAuswahlwert, (v) => (this.pfostenfarbeAuswahlwert_ = v));
    this.mostRecentBodenbefestigung = null;
    setAuswahlwert(
      json?.bodenbefestigungAuswahlwert,
      (v) => (this.bodenbefestigungAuswahlwert_ = v)
    );
    setAuswahlwert(json?.elementhalterAuswahlwert, (v) => (this.elementhalterAuswahlwert_ = v));
    setAuswahlwert(
      json?.verteilungsstrategieAuswahlwert,
      (v) => (this.verteilungsstrategieAuswahlwert_ = v)
    );

    this.segmente.forEach((segment: Segment) => {
      const parts = segment.getPartsAndPfosten();
      parts.forEach((part, index) => {
        if (part.isElement) {
          if (parts[index - 1]?.isPfosten) {
            part.pfostenLinks = parts[index - 1];
            parts[index - 1].elemente.push(part);
          }
          if (parts[index + 1]?.isPfosten) {
            part.pfostenRechts = parts[index + 1];
            parts[index + 1].elemente.push(part);
          }
        }
      });
    });
    this.userDefinedArticles = (json.userDefinedArticles ?? []).map((a) => {
      return { ...a };
    });
    this.customAnzahlen = _.isPlainObject(json.customAnzahlen) ? { ...json.customAnzahlen } : {};
    this.initFüllungAuswahlwertHistory();
    this.zauneditorVisited = json.zauneditorVisited;
    this.grundrissDialogOpen = json.grundrissDialogOpen ?? false;
    return this;
  }

  updateStückliste() {
    ({
      bestellliste: this.bestellliste,
      gesamtpreis: this.gesamtpreis,
      baugruppen: this.baugruppen,
    } = createStückliste(this));

    const logitbefore = APP.logStückliste;
    APP.logStückliste = false;
    try {
      // erzeuge Teil-Stücklisten für ZaunCircleMenuItemInfo

      // filtere alle Parts, die vom Typ her prinzipiell eine bestellliste haben
      const partsToBeUpdated = this.getPartsAndPfosten().filter(
        (p) => p.bestellliste !== undefined
      );
      let i = 0;
      const groupedPartsToBeUpdated = _.groupBy(partsToBeUpdated, (x) => x.ObjectGroupTag ?? i++);

      Object.entries(groupedPartsToBeUpdated).forEach(([key, elements]) => {
        const { bestellliste, gesamtpreis } = createStückliste({
          collectArtikel: (iterator) => elements.forEach((e) => e.collectArtikel(iterator)),
        });
        elements.forEach((e) => ([e.bestellliste, e.gesamtpreis] = [bestellliste, gesamtpreis]));
      });
    } finally {
      APP.logStückliste = logitbefore;
    }
  }

  collectArtikel(iterator: StücklistenIterator) {
    this.segmente.forEach((segment) => segment.collectArtikel(iterator));
    this.ecken
      .filter((ecke) => ecke.pfosten)
      .forEach((ecke) => ecke.pfosten.collectArtikel(iterator));
    this.eckadapter.forEach((e) => e.collectArtikel(iterator));
    this.collectArtikelFürLichtleisten(iterator);
  }

  collectArtikelFürLichtleisten(iterator: StücklistenIterator) {
    if (this.trafoTrees.length == 0) {
      return;
    }

    // Trafos
    const trafoTyp = getTrafoTypAusgewöhlt();
    if (trafoTyp == null) {
      return;
    }

    const trafoMeta = APP.richMetadata.findObjekt(trafoTyp.Key);
    const anzahlTrafos = this.aufbauten.filter((a) => a.isTrafo()).length;
    iterator({ ObjektMeta: trafoMeta, ObjectGroupTag: undefined, Anzahl: anzahlTrafos });

    // Kabel
    this.kabel
      .filter((kabel) => !(kabel.isTrafoKabel && this.kabel.length > 1))
      .forEach((kabel) => {
        const key = kabel.länge <= 10 ? "Licht_Basiskabel_10m" : "Licht_Basiskabel_30m";
        const ObjektMeta = APP.richMetadata.findEnsureAnyObjekt(key);
        iterator({
          ObjektMeta,
          Anzahl: 1,
        });
      });

    // Splitter
    const splitter = APP.richMetadata.findEnsureAnyObjekt("Licht_Splitter");
    iterator({
      ObjektMeta: splitter,
      Anzahl: this.lichtleistenSplitter,
    });

    // Zubehör
    APP.richMetadata
      .getZubehöre("Licht_Zubehör", this.lichtleistenZubehörAnzahl)
      .forEach(({ zubehör, anzahl }) =>
        iterator({
          ObjektMeta: zubehör,
          Anzahl: anzahl,
        })
      );
  }

  maybeAskElementSeitenwechsel() {
    const anzahlErreicht =
      this.elementeSeiteGewechselt.length > this.elementeSeiteGewechseltFragenAnzahl;
    if (anzahlErreicht) {
      const elementIsFlippedNormal = (e) => e?.segment.flippedNormal;
      const firstElement = this.elementeSeiteGewechselt.first();
      const seiteGewechselt = firstElement?.seiteGewechselt;
      const allTheSame = this.elementeSeiteGewechselt.every(
        (e) => e.seiteGewechselt == seiteGewechselt
      );
      if (allTheSame) {
        this.elementeSeiteGewechselt.clear();
        const seitenwechsel = async () => {
          await Commons.sleep(300);
          this.setSelectedObjects(null);
          await Commons.sleep(800);
          this.getElemente().forEach(
            (e) =>
              (e.seiteGewechselt =
                elementIsFlippedNormal(e) !== elementIsFlippedNormal(firstElement)
                  ? !seiteGewechselt
                  : seiteGewechselt)
          );
          APP.dirty();
          await Commons.sleep(600);
          Dialogs.showToast(
            I18N("Ist erledigt. Ich habe überall die Seiten einheitlich ausgerichtet.")
          );
        };
        Dialogs.askQuestion(
          I18N("Soll ich für sie bei allen Elementen die Außenseite entsprechend wechseln?"),
          [
            {
              label: "Nein",
              action: () => (this.elementeSeiteGewechseltFragenAnzahl += 2),
            },
            { label: "Ja", primary: true, action: seitenwechsel },
          ]
        );
      }
    }
  }

  maybeAskAnkerInnen() {
    const anzahlErreicht = this.ankerAußen.length > this.ankerAußenFragenAnzahl;
    if (anzahlErreicht) {
      const seitenwechsel = this.ankerAußen.first()?.ankerInnen;
      const allTheSame = this.ankerAußen.every((e) => e.ankerInnen == seitenwechsel);
      if (allTheSame) {
        this.ankerAußen.clear();
        const doSeitenwechsel = async () => {
          await Commons.sleep(300);
          this.setSelectedObjects(null);
          await Commons.sleep(800);
          this.getPfosten().forEach((e) => (e.ankerInnen = seitenwechsel));
          APP.dirty();
          await Commons.sleep(600);
          Dialogs.showToast(I18N("Ist erledigt. Ich habe alle Anker nach innen ausgerichtet."));
        };
        Dialogs.askQuestion(
          I18N(
            "Ihre Anker liegen außerhalb des gewählten Grundrisses. Soll ich die betroffenen Anker nach innen ausrichten?"
          ),
          [
            { label: "Nein", action: () => (this.ankerAußenFragenAnzahl += 1) },
            { label: "Ja", primary: true, action: doSeitenwechsel },
          ]
        );
      }
    }
  }

  maybeNotifyPfostenartWechsel(lastSet: Map<number, MAuswahlwert>) {
    if (APP.pageName == "Zauneditor" && !this.updatingPfostenart && !this.isSeitenleiste) {
      const newSet = this._getPfostenIdPfostenartAuswahlwertMap();
      let hasChanges = false;
      [...newSet.entries()].forEach(([key, auswahlwert]) => {
        hasChanges = hasChanges || (lastSet.has(key) && lastSet.get(key) != auswahlwert);
      });
      if (hasChanges) {
        Dialogs.showToast(
          I18N("Durch Ihre Aktion wurde die Pfostenart eines oder mehrerer Pfosten geändert.")
        );
      }
    }
  }

  maybeShowInvalidPairs(addWarning: (elemente: (ZElement | Pfosten)[], warning: string) => void) {
    this.segmente.forEach((s) => {
      const partsAndPfosten = s.getPartsAndPfostenWithoutEmpties();
      const invalidationKey = (invalid: any) =>
        String(invalid?.Key ?? invalid?.id ?? invalid?.Warnung ?? "");

      const dedupeInvalidationData = (invalidationData: any[]) =>
        _.uniqBy(invalidationData, (invalid) => invalidationKey(invalid));

      const getZubehörMetas = (part: Pfosten | ZElement) =>
        (part as any)?.isTor && (part as ZElement)?.zubehörTeile
          ? _.uniqBy(
              (part as ZElement).zubehörTeile
                .map((z) => z?.zubehör)
                .filter((zubehör) => zubehör != null),
              (meta) => meta?.Key ?? meta?.id
            )
          : [];

      const invalidPairCases: {
        pair: (ZElement | Pfosten)[];
        invalidationData: any[];
      }[] = [];

      // 1) Benachbarte parts/pfosten paarweise prüfen
      const adjacentPairs = Commons.pairwise(partsAndPfosten) as [
        Pfosten | ZElement,
        Pfosten | ZElement,
      ][];
      adjacentPairs.forEach(([a, b]) => {
        const invalidationData = dedupeInvalidationData(
          APP.richMetadata.isInvalidMetaCombination(a?.meta as any, b?.meta as any)
        );
        if (invalidationData.length > 0) {
          invalidPairCases.push({ pair: [a, b], invalidationData });
        }
      });

      // 2) Part gegen eigene Zubehörteile prüfen
      partsAndPfosten.forEach((part) => {
        const zubehörMetas = getZubehörMetas(part);
        if (part?.meta == null || zubehörMetas.length == 0) {
          return;
        }

        const invalidationData = dedupeInvalidationData(
          zubehörMetas.flatMap((zubehörMeta) =>
            APP.richMetadata.isInvalidMetaCombination(part.meta as any, zubehörMeta as any)
          )
        );

        if (invalidationData.length > 0) {
          invalidPairCases.push({ pair: [part], invalidationData });
        }
      });

      invalidPairCases.forEach(({ pair, invalidationData }) => {
        const warnungText = _.uniq(
          invalidationData.map((i) => i.Warnung).filter((warnung) => !Commons.isEmpty(warnung))
        ).join("\n");
        if (!Commons.isEmpty(warnungText)) {
          addWarning(pair, warnungText);
        }
      });
    });
  }

  copySelected() {
    this.copiedEntity = this.selectedObjects[0];
  }

  cutSelected() {
    if (this.selectedObjects.length != 1) {
      return;
    }
    this.copiedEntity = this.selectedObjects[0];
    this.removeSelectedObjects();
    APP.dirty();
  }

  pasteSelected() {
    if (this.selectedObjects.length == 0 || this.copiedEntity == null) {
      return;
    }
    if (this.copiedEntity.isEmpty) {
      this.removeSelectedObjects();
    } else {
      const copied = this.copiedEntity;
      const removed = [];
      this.selectedObjects.forEach((selected) => {
        if (
          ["isElement", "isPfosten", "isMauer", "isEmpty"].every(
            (key) => selected[key] == copied[key]
          ) &&
          !(copied.isAufbau && selected.isAufbau)
        ) {
          if (!copied.isEmpty) {
            this.changeSelectedZaunElemente({
              massAuswahlwert: copied.massAuswahlwert,
              füllungAuswahlwert: copied.füllungAuswahlwert,
              size: copied.size,
            });
          }
          const snap = selected.snap;
          selected.copy(copied);
          selected.snap = snap;
        } else if (!copied.isPfosten && !selected.isPfosten && !selected.isAufbau) {
          const segment = selected.segment;
          const x = segment.getX(selected, 0.5);
          removed.push({ segment, x });
          !selected.isEmpty && selected.uiRemove(false);
        }
      });
      this.update3d();
      const empties = _.uniq(removed.map(({ segment, x }) => segment.getPartAtPositionX(x)));
      empties.forEach((empty) => {
        if (copied.isElement) {
          empty.fillWithElements(copied, {
            allowMassElement: true,
            minimalOneElement: false,
          });
        } else {
          setEmptyAsMauer(empty);
        }
      });
    }
    APP.dirty();
  }

  async moveZaunelementSelection(deltaIndex: number) {
    if (!this.selectedObjects[0]) {
      return;
    }
    const parts = this.getPartsAndPfosten().filter((p) => !p.isUMProfil);
    const index = parts.findIndex((p) => p == this.selectedObjects[0]);
    const newIndex = (index + deltaIndex) % parts.length;
    const newSelected = parts[newIndex];
    const zauneditorPage = APP.pageInstance as Zauneditor;
    const circleMenu = zauneditorPage?.zaunCircleMenu?.current;
    circleMenu.hideSelectCircle();
    await zauneditorPage.setSelectedObjects(newSelected);
    circleMenu.update();
  }

  toGPT(): any {
    const vToJson = (v) => v?.toArray().map((x) => Maths.round(x, 2)) ?? null;
    const json = {
      zaunart: this.zaunart?.Key,
      serie: this.serie?.Key,
      grundriss: this.grundriss.toJSON(),
      segmente: this.segmente.map((x) => ({
        direction: vToJson(x.direction),
        breite: x.breite,
        parts: x
          .getPartsAndPfosten()
          .map((x) =>
            x.isPfosten
              ? {
                  type: "Pfosten",
                  pfostenfarbe: x.pfostenfarbeAuswahlwert?.Key,
                  size: vToJson(x.size),
                }
              : x.isElement
                ? {
                    type: "Element",
                    füllung: x.füllungAuswahlwert?.Key,
                    size: vToJson(x.size),
                    position: x.segment.getX(x, 0),
                  }
                : null
          )
          .filter((x) => x != null),
      })),
    };
    return json;
  }

  getElementMinBreite() {
    return 0.1;
  }

  updateAuswahlAccessoren() {
    // console.time("updateAuswahlAccessoren");
    const elemente = this.getSelectedOrAllElemente();
    const pfosten = this.getSelectedOrAllPfosten();
    const elementAuswahlAccessoren = filterElementAuswahlAccessorenForMany(elemente);
    const pfostenAuswahlAccessoren = filterPfostenAuswahlAccessorenForMany(pfosten);
    this.auswahlAccessoren = {
      ...elementAuswahlAccessoren,
      ...pfostenAuswahlAccessoren,
    };
    // console.timeEnd("updateAuswahlAccessoren");
  }

  verteileBauseitsKürzbareElementeGleichmäßig(selectedParts: any[]) {
    this.forNurMasseUpdaten(() => {
      const map = Commons.groupBy(selectedParts, (p) => p.segment);
      for (const [segment, parts] of map) {
        segment.verteileBauseitsKürzbareElementeGleichmäßig(parts);
      }
    });
  }

  tauscheBenachbarteElemente(elements: ZElement[]) {
    const [nachbar, element] = elements.sort((a, b) => a.position.x - b.position.x);

    if ([nachbar, element].some((e) => (e as any).isEmpty)) {
      let empty, other;
      if ((nachbar as any).isEmpty) {
        empty = nachbar;
        other = element;
      } else {
        empty = element;
        other = nachbar;
      }
      const otherDir = empty.nachbarLinks == other ? -1 : +1;

      // Vor Tausch immer die benachbarten Snaps anpassen (Nachbar von Empty auf
      // Emptysnap setzen, wenn snap === 0)
      const otherSnap = other.snap;
      const { nachbarLinks, nachbarRechts } = empty;
      const [nachbarEmpty, andererNachbarEmpty] =
        empty.snap == -1 ? [nachbarRechts, nachbarLinks] : [nachbarLinks, nachbarRechts];
      if (nachbarEmpty?.isElement && nachbarEmpty?.snap === 0) {
        nachbarEmpty.snap = empty.snap;
      }

      // Wenn Richtung von Empty u. Element == der Richtung in die das Empty wandert, dann
      // muss das Element einen Snap von 0 bekommen (da sonst Empty vor Element).
      // Wenn Empty anEcke und Snapdirection zeigt von Ecke weg, dann müssen Empty und
      // Element hin zur Ecke snappen, sonst entsteht später eine Lücke.
      if (empty.snap === other.snap) {
        if (empty.snap === otherDir) {
          other.snap = andererNachbarEmpty?.snap === otherDir ? 0 : andererNachbarEmpty?.snap;
        } else if (andererNachbarEmpty) {
          other.snap = andererNachbarEmpty?.snap;
        }
        if (!empty.nachbarLinks && empty.snap === +1) {
          empty.snap = -1;
          other.snap = -1;
        } else if (!empty.nachbarRechts && empty.snap === -1) {
          empty.snap = +1;
          other.snap = +1;
        }
      } else if (empty.snap === -other.snap) {
        other.snap = 0;
        empty.snap = otherSnap;
        andererNachbarEmpty.snap = otherSnap;
      }

      const nachbarElementOther = otherDir === -1 ? other.nachbarLinks : other.nachbarRechts;
      if (otherSnap === 0 && nachbarElementOther?.snap === empty.snap) {
        nachbarElementOther.snap = 0;
      }

      if (nachbarElementOther?.anGrenzpfosten) {
        const eckeDir = nachbarElementOther.nachbarLinks ? +1 : -1;
        nachbarElementOther.snap = eckeDir;
        empty.snap = eckeDir;
      }
    } else {
      const elementSnap = element.snap;
      element.snap = nachbar.snap;
      nachbar.snap = elementSnap;
    }
    element.position.x = nachbar.position.x;
    nachbar.position.x = nachbar.position.x + element.breite;
    this.update3d();
    const elementEckpfosten = element.getPfosten().find((p) => p.ecke);
    const nachbarEckpfosten = nachbar.getPfosten().find((p) => p.ecke);
    if (elementEckpfosten && elementEckpfosten === nachbarEckpfosten) {
      // Das sollte eigentlich nicht vorkommen.. Hier teilen sich zwei Elemente einen Pfosten, der
      // fälschlicher Weise als Eckpfosten deklariert wurde.
      // Desshalb entfernen wir hier die falsche Ecke und lassen sie neu erzeugen.
      elementEckpfosten.ecke = null;
      nachbarEckpfosten.ecke = null;
      this.ecken = this.ecken.filter((e) => e.pfosten != elementEckpfosten);
      this.update3d();
    }
    APP.zoomCameraToPart(element);
  }

  initFüllungAuswahlwertHistory() {
    const bag = new Bag<MAuswahlwert>();
    (
      filterPathIntersectionCached("Arrangement.js:2742")(
        this.serie,
        (p: PSerie) => elementOrTor(p.DetailSerie).Füllung.Auswahlwert
      ) as MAuswahlwert[]
    ).forEach((füllungAuswahlwert) => bag.set(füllungAuswahlwert, 0));
    bag.inc(this.füllungAuswahlwertDefault, 1);
    this.getElemente().forEach((element) => bag.inc(element.füllungAuswahlwert, 1));
    this.füllungAuswahlwertHistory = _.sortBy([...bag.entries()], (a) => a[1])
      .map((a) => a[0])
      .reverse() as MAuswahlwert[];
  }

  getDefaultLichtleistenZubehörAnzahl() {
    return getDefaultAnzahl(findAuswahl("Lichtleisten_Zubehör"));
  }

  maybeRemoveElementeAusFremderSerie() {
    if (APP.isTorkonfigurator) return;
    const elemente = this.getElemente();
    const elementeMitFalscherSerie = elemente.filter(
      (e) => e.meta && !this.serie?.DetailSerie?.includes(e.meta.DetailSerie[0])
    );
    let anzahlGelöschterElemente = 0;
    if (elemente.length == 1 || elemente.length != elementeMitFalscherSerie.length) {
      elementeMitFalscherSerie.forEach((e) => {
        anzahlGelöschterElemente++;
        e.uiRemove();
      });
    }
    if (anzahlGelöschterElemente > 0 && APP.arrangement.zauneditorVisited) {
      const warnung = I18N(
        "Es wurden %s Elemente oder Tore gelöscht, weil sie nicht zu der gewählten Serie passen.",
        anzahlGelöschterElemente
      );
      Dialogs.showToast(warnung, { type: "warning" });
    }
  }

  maybeHighlightBreadcrumb(pageName) {
    if (pageName == undefined) {
      return;
    }

    const pageNameToLowerCase = pageName.toLowerCase();

    const joyrideTourShown =
      JSON.parse(localStorage.getItem("joyrideTourStep"))?.[
        pageNameToLowerCase === "grundriss" ? "zauneditor" : "grundriss"
      ] === -1;
    const breadcrumbsHighlighted = JSON.parse(localStorage.getItem("breadcrumbsHighlighted"));
    let hasHighlighted = breadcrumbsHighlighted?.[pageNameToLowerCase];

    const element = document.querySelector(`[data-button-key="${pageName}"]`);
    if (!hasHighlighted && joyrideTourShown && element) {
      element.classList.add("breadcrumb-highlight");
      localStorage["breadcrumbsHighlighted"] = JSON.stringify({
        ...(breadcrumbsHighlighted ?? { grundriss: false, zauneditor: false }),
        [pageNameToLowerCase]: true,
      });

      setTimeout(() => {
        element.classList.remove("breadcrumb-highlight");
      }, 10000);
    } else {
      if (!joyrideTourShown) {
        setTimeout(() => APP.arrangement.maybeHighlightBreadcrumb(pageName), 5000);
      }
    }
  }

  maybeSetBodenbefestigungEinbetoniert(part) {
    const pfosten = part.getPfosten();
    const einbetoniertAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
    pfosten.forEach((p) => {
      if (p.bodenbefestigungAuswahlwert !== einbetoniertAuswahlwert) {
        p.bodenbefestigungAuswahlwert = einbetoniertAuswahlwert;
      }
    });
    APP.update3d();
  }

  maybeGetDreifachtorPartnerIndex(index: number, ArtikelID: string) {
    const parts = APP.arrangement.getParts();
    const element = parts?.find((e: ZElement) => e.elementNr === index);
    if (
      element == undefined ||
      !element.isDreifachtor ||
      element.meta.Artikelrelation?.some(({ Artikel }) => Artikel.ArtikelID == ArtikelID)
    ) {
      return index;
    }
    return getDreifachtorPartnerElement(element)?.elementNr;
  }

  logit() {
    this.segmente.forEach((s, index) => {
      console.log(`Segment ${index}:`);
      s.logit();
    });
  }
}

export function ghostPool(x: Jaco) {
  return (x.arrangement as Arrangement).ghostPool;
}
